// Copyright (c) 2009, Baidu Inc. All rights reserved.
//
// Licensed under the BSD License
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://tangram.baidu.com/license.html
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

/**
* @namespace T Tangram七巧板
* @name T
* @version 1.3.9
*/

/**
 * 声明baidu包
 * @author: allstar, erik, meizz, berg
 */
window.T = window.baidu || { version: "1.3.9" };

window.baidu = window.T;

//提出guid，防止在与老版本Tangram混用时
//在下一行错误的修改window[undefined]
baidu.guid = "$BAIDU$";

//Tangram可能被放在闭包中
//一些页面级别唯一的属性，需要挂载在window[baidu.guid]上
baidu.$$ = window[baidu.guid] = window[baidu.guid] || { global: {} };

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/fn.js
 * author: berg
 * version: 1.0.0
 * date: 2010/11/02
 */


/**
 * @namespace baidu.fn 对方法的操作，解决内存泄露问题。
 */
baidu.fn = baidu.fn || {};
/*
 * Tangram
 * Copyright 2011 Baidu Inc. All rights reserved.
 */



/**
 * 这是一个空函数，用于需要排除函数作用域链干扰的情况.
 * @author rocy
 * @name baidu.fn.blank
 * @function
 * @grammar baidu.fn.blank()
 * @meta standard
 * @return {Function} 一个空函数
 * @version 1.3.3
 */
baidu.fn.blank = function () { };
baidu.fn.bind = function (func, scope) {
  var xargs = arguments.length > 2 ? [].slice.call(arguments, 2) : null;
  return function () {
    var fn = baidu.lang.isString(func) ? scope[func] : func,
      args = (xargs) ? xargs.concat([].slice.call(arguments, 0)) : arguments;
    return fn.apply(scope || fn, args);
  };
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/array.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * @namespace baidu.array 操作数组的方法。
 */

baidu.array = baidu.array || {};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/array/each.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 遍历数组中所有元素
 * @name baidu.array.each
 * @function
 * @grammar baidu.array.each(source, iterator[, thisObject])
 * @param {Array} source 需要遍历的数组
 * @param {Function} iterator 对每个数组元素进行调用的函数，该函数有两个参数，第一个为数组元素，第二个为数组索引值，function (item, index)。
 * @param {Object} [thisObject] 函数调用时的this指针，如果没有此参数，默认是当前遍历的数组
 * @remark
 * each方法不支持对Object的遍历,对Object的遍历使用baidu.object.each 。
 * @shortcut each
 * @meta standard
 *
 * @returns {Array} 遍历的数组
 */

baidu.each = baidu.array.forEach = baidu.array.each = function (source, iterator, thisObject) {
  var returnValue, item, i, len = source.length;
  if ('function' == typeof iterator) {
    for (i = 0; i < len; i++) {
      item = source[i];
      //TODO
      //此处实现和标准不符合，标准中是这样说的：
      //If a thisObject parameter is provided to forEach, it will be used as the this for each invocation of the callback. If it is not provided, or is null, the global object associated with callback is used instead.
      returnValue = iterator.call(thisObject || source, item, i);

      if (returnValue === false) {
        break;
      }
      if (returnValue === 'continue') {
        continue;
      }
    }
  }
  return source;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 从数组中筛选符合条件的元素
 * @name baidu.array.filter
 * @function
 * @grammar baidu.array.filter(source, iterator[, thisObject])
 * @param {Array} source 需要筛选的数组
 * @param {Function} iterator 对每个数组元素进行筛选的函数，该函数有两个参数，第一个为数组元素，第二个为数组索引值，function (item, index)，函数需要返回true或false
 * @param {Object} [thisObject] 函数调用时的this指针，如果没有此参数，默认是当前遍历的数组
 * @meta standard
 * @see baidu.array.find
 *
 * @returns {Array} 符合条件的数组项集合
 */

baidu.array.filter = function (source, iterator, thisObject) {
  var result = [],
    resultIndex = 0,
    len = source.length,
    item,
    i;

  if ('function' == typeof iterator) {
    for (i = 0; i < len; i++) {
      item = source[i];
      //TODO
      //和标准不符，see array.each
      if (true === iterator.call(thisObject || source, item, i)) {
        // resultIndex用于优化对result.length的多次读取
        result[resultIndex++] = item;
      }
    }
  }

  return result;
};

/**
 * 查询数组中指定元素的索引位置
 * @name baidu.array.indexOf
 * @function
 * @grammar baidu.array.indexOf(source, match[, fromIndex])
 * @param {Array} source 需要查询的数组
 * @param {Any} match 查询项
 * @param {number} [fromIndex] 查询的起始位索引位置，如果为负数，则从source.length+fromIndex往后开始查找
 * @see baidu.array.find,baidu.array.lastIndexOf
 *
 * @returns {number} 指定元素的索引位置，查询不到时返回-1
 */
baidu.array.indexOf = function (source, match, fromIndex) {
  var len = source.length,
    iterator = match;

  fromIndex = fromIndex | 0;
  if (fromIndex < 0) {//小于0
    fromIndex = Math.max(0, len + fromIndex)
  }
  for (; fromIndex < len; fromIndex++) {
    if (fromIndex in source && source[fromIndex] === match) {
      return fromIndex;
    }
  }

  return -1;
};

/**
 * 过滤数组中的相同项。如果两个元素相同，会删除后一个元素。
 * @name baidu.array.unique
 * @function
 * @grammar baidu.array.unique(source[, compareFn])
 * @param {Array} source 需要过滤相同项的数组
 * @param {Function} [compareFn] 比较两个数组项是否相同的函数,两个数组项作为函数的参数。
 *
 * @returns {Array} 过滤后的新数组
 */
baidu.array.unique = function (source, compareFn) {
  var len = source.length,
    result = source.slice(0),
    i, datum;

  if ('function' != typeof compareFn) {
    compareFn = function (item1, item2) {
      return item1 === item2;
    };
  }

  // 从后往前双重循环比较
  // 如果两个元素相同，删除后一个
  while (--len > 0) {
    datum = result[len];
    i = len;
    while (i--) {
      if (compareFn(datum, result[i])) {
        result.splice(len, 1);
        break;
      }
    }
  }

  return result;
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/array/remove.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/30
 */



/**
 * 移除数组中的项
 * @name baidu.array.remove
 * @function
 * @grammar baidu.array.remove(source, match)
 * @param {Array} source 需要移除项的数组
 * @param {Any} match 要移除的项
 * @meta standard
 * @see baidu.array.removeAt
 *
 * @returns {Array} 移除后的数组
 */
baidu.array.remove = function (source, match) {
  var len = source.length;

  while (len--) {
    if (len in source && source[len] === match) {
      source.splice(len, 1);
    }
  }
  return source;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/array/removeAt.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/30
 */



/**
 * 移除数组中的项
 * @name baidu.array.removeAt
 * @function
 * @grammar baidu.array.removeAt(source, index)
 * @param {Array} source 需要移除项的数组
 * @param {number} index 要移除项的索引位置
 * @see baidu.array.remove
 * @meta standard
 * @returns {Any} 被移除的数组项
 */
baidu.array.removeAt = function (source, index) {
  return source.splice(index, 1)[0];
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/browser.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * @namespace baidu.browser 判断浏览器类型和特性的属性。
 */
baidu.browser = baidu.browser || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

baidu.ua = navigator.userAgent || "";

/**
 * 判断是否为firefox浏览器
 * @property firefox firefox版本号
 * @grammar baidu.browser.firefox
 * @meta standard
 * @see baidu.browser.ie,baidu.browser.safari,baidu.browser.opera,baidu.browser.chrome
 * @return {Number} firefox版本号
 */
baidu.browser.firefox = /firefox\/(\d+\.\d+)/i.test(baidu.ua) ? + RegExp['\x241'] : undefined;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



//IE 8下，以documentMode为准
//在百度模板中，可能会有$，防止冲突，将$1 写成 \x241
/**
 * 判断是否为ie浏览器
 * @name baidu.browser.ie
 * @field
 * @grammar baidu.browser.ie
 * @returns {Number} IE版本号
 */
baidu.browser.ie = baidu.ie = /msie (\d+\.\d+)/i.test(baidu.ua) ? (document.documentMode || + RegExp['\x241']) : undefined;
baidu.browser.ieTrue = baidu.ieTrue = /msie (\d+\.\d+)/i.test(baidu.ua) ? +RegExp['\x241'] : undefined;

(function () {
  if (!baidu.browser.ie && /Trident\//i.test(baidu.ua)) {
    var version = /rv:(\d+\.\d+)/i.test(baidu.ua) ? RegExp['\x241'] : undefined;
    if (version) {
      version = parseInt(version, 10);
      baidu.browser.ie = baidu.ie = version;
      baidu.browser.ieTrue = baidu.ieTrue = baidu.browser.ie;
    }
  }
})();
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/browser/isGecko.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 判断是否为gecko内核
 * @property isGecko
 * @grammar baidu.browser.isGecko
 * @meta standard
 * @see baidu.browser.isWebkit
 * @returns {Boolean} 布尔值
 */
baidu.browser.isGecko = /gecko/i.test(baidu.ua) && !/like gecko/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/browser/isStrict.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 判断是否严格标准的渲染模式
 * @property isStrict
 * @grammar baidu.browser.isStrict
 * @meta standard
 * @returns {Boolean} 布尔值
 */
baidu.browser.isStrict = document.compatMode == "CSS1Compat";
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/browser/isWebkit.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 判断是否为webkit内核
 * @property isWebkit
 * @grammar baidu.browser.isWebkit
 * @meta standard
 * @see baidu.browser.isGecko
 * @returns {Boolean} 布尔值
 */
baidu.browser.isWebkit = /webkit/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/browser/opera.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 判断是否为opera浏览器
 * @property opera opera版本号
 * @grammar baidu.browser.opera
 * @meta standard
 * @see baidu.browser.ie,baidu.browser.firefox,baidu.browser.safari,baidu.browser.chrome
 * @returns {Number} opera版本号
 */

/**
 * opera 从10开始不是用opera后面的字符串进行版本的判断
 * 在Browser identification最后添加Version + 数字进行版本标识
 * opera后面的数字保持在9.80不变
 */
baidu.browser.opera = /opera(\/| )(\d+(\.\d+)?)(.+?(version\/(\d+(\.\d+)?)))?/i.test(baidu.ua) ? + (RegExp["\x246"] || RegExp["\x242"]) : undefined;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

/*
 * 兼容浏览器为safari或ipad,其中,一段典型的ipad UA 如下:
 * Mozilla/5.0(iPad; U; CPU iPhone OS 3_2 like Mac OS X; en-us) AppleWebKit/531.21.10 (KHTML, like Gecko) Version/4.0.4 Mobile/7B314 Safari/531.21.10
 */

/**
 * 判断是否为safari浏览器, 支持ipad
 * @property safari safari版本号
 * @grammar baidu.browser.safari
 * @meta standard
 * @see baidu.browser.ie,baidu.browser.firefox,baidu.browser.opera,baidu.browser.chrome
 */
baidu.browser.safari = /(\d+\.\d)?(?:\.\d)?\s+safari\/?(\d+\.\d+)?/i.test(baidu.ua) && !/chrome/i.test(baidu.ua) ? + (RegExp['\x241'] || RegExp['\x242']) : undefined;

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/cookie.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */
/**
 * @namespace baidu.platform 判断平台类型和特性的属性。
 * @author jz
 */
baidu.platform = baidu.platform || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断是否为android平台
 * @property android 是否为android平台
 * @grammar baidu.platform.android
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.windows,baidu.platform.macintosh,baidu.platform.iphone,baidu.platform.ipad
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isAndroid = /android/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

/**
 * 判断是否为Winphone平台
 * @property Winphone 是否为ipad平台
 * @grammar baidu.platform.Winphone
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.windows,baidu.platform.macintosh,baidu.platform.iphone,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isWinphone = /windows phone/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断是否为ipad平台
 * @property ipad 是否为ipad平台
 * @grammar baidu.platform.ipad
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.windows,baidu.platform.macintosh,baidu.platform.iphone,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isIpad = /ipad/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断是否为iphone平台
 * @property iphone 是否为iphone平台
 * @grammar baidu.platform.iphone
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.windows,baidu.platform.macintosh,baidu.platform.ipad,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isIphone = /iphone/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断是否为macintosh平台
 * @property macintosh 是否为macintosh平台
 * @grammar baidu.platform.macintosh
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.windows,baidu.platform.iphone,baidu.platform.ipad,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isMacintosh = /macintosh/i.test(baidu.ua);
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断是否为windows平台
 * @property windows 是否为windows平台
 * @grammar baidu.platform.windows
 * @meta standard
 * @see baidu.platform.x11,baidu.platform.macintosh,baidu.platform.iphone,baidu.platform.ipad,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isWindows = /windows/i.test(baidu.ua) || navigator.platform == 'Win32' || navigator.platform == 'Windows';
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */


/**
 * 判断是否为x11平台
 * @property x11 是否为x11平台
 * @grammar baidu.platform.x11
 * @meta standard
 * @see baidu.platform.windows,baidu.platform.macintosh,baidu.platform.iphone,baidu.platform.ipad,baidu.platform.android
 * @return {Boolean} 布尔值
 * @author jz
 */
baidu.platform.isX11 = /x11/i.test(baidu.ua);

/**
 * @namespace baidu.date 操作日期的方法。
 */
baidu.date = baidu.date || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/number.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/2
 */


/**
 * @namespace baidu.number 操作number的方法。
 */
baidu.number = baidu.number || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/number/pad.js
 * author: dron, erik, berg
 * version: 1.1.0
 * date: 20100412
 */



/**
 * 对目标数字进行0补齐处理
 * @name baidu.number.pad
 * @function
 * @grammar baidu.number.pad(source, length)
 * @param {number} source 需要处理的数字
 * @param {number} length 需要输出的长度
 *
 * @returns {string} 对目标数字进行0补齐处理后的结果
 */
baidu.number.pad = function (source, length) {
  var pre = "",
    negative = (source < 0),
    string = String(Math.abs(source));

  if (string.length < length) {
    pre = (new Array(length - string.length + 1)).join('0');
  }

  return (negative ? "-" : "") + pre + string;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/date/format.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/04
 */




/**
 * 对目标日期对象进行格式化
 * @name baidu.date.format
 * @function
 * @grammar baidu.date.format(source, pattern)
 * @param {Date} source 目标日期对象
 * @param {string} pattern 日期格式化规则
 * @remark
 *
<b>格式表达式，变量含义：</b><br><br>
hh: 带 0 补齐的两位 12 进制时表示<br>
h: 不带 0 补齐的 12 进制时表示<br>
HH: 带 0 补齐的两位 24 进制时表示<br>
H: 不带 0 补齐的 24 进制时表示<br>
mm: 带 0 补齐两位分表示<br>
m: 不带 0 补齐分表示<br>
ss: 带 0 补齐两位秒表示<br>
s: 不带 0 补齐秒表示<br>
yyyy: 带 0 补齐的四位年表示<br>
yy: 带 0 补齐的两位年表示<br>
MM: 带 0 补齐的两位月表示<br>
M: 不带 0 补齐的月表示<br>
dd: 带 0 补齐的两位日表示<br>
d: 不带 0 补齐的日表示

 *
 * @returns {string} 格式化后的字符串
 */

baidu.date.format = function (source, pattern) {
  if ('string' != typeof pattern) {
    return source.toString();
  }

  function replacer (patternPart, result) {
    pattern = pattern.replace(patternPart, result);
  }

  var pad = baidu.number.pad,
    year = source.getFullYear(),
    month = source.getMonth() + 1,
    date2 = source.getDate(),
    hours = source.getHours(),
    minutes = source.getMinutes(),
    seconds = source.getSeconds();

  replacer(/yyyy/g, pad(year, 4));
  replacer(/yy/g, pad(parseInt(year.toString().slice(2), 10), 2));
  replacer(/MM/g, pad(month, 2));
  replacer(/M/g, month);
  replacer(/dd/g, pad(date2, 2));
  replacer(/d/g, date2);

  replacer(/HH/g, pad(hours, 2));
  replacer(/H/g, hours);
  replacer(/hh/g, pad(hours % 12, 2));
  replacer(/h/g, hours % 12);
  replacer(/mm/g, pad(minutes, 2));
  replacer(/m/g, minutes);
  replacer(/ss/g, pad(seconds, 2));
  replacer(/s/g, seconds);

  return pattern;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/date/parse.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/04
 */



/**
 * 将目标字符串转换成日期对象
 * @name baidu.date.parse
 * @function
 * @grammar baidu.date.parse(source)
 * @param {string} source 目标字符串
 * @remark
 *
对于目标字符串，下面这些规则决定了 parse 方法能够成功地解析： <br>
<ol>
<li>短日期可以使用“/”或“-”作为日期分隔符，但是必须用月/日/年的格式来表示，例如"7/20/96"。</li>
<li>以 "July 10 1995" 形式表示的长日期中的年、月、日可以按任何顺序排列，年份值可以用 2 位数字表示也可以用 4 位数字表示。如果使用 2 位数字来表示年份，那么该年份必须大于或等于 70。 </li>
<li>括号中的任何文本都被视为注释。这些括号可以嵌套使用。 </li>
<li>逗号和空格被视为分隔符。允许使用多个分隔符。 </li>
<li>月和日的名称必须具有两个或两个以上的字符。如果两个字符所组成的名称不是独一无二的，那么该名称就被解析成最后一个符合条件的月或日。例如，"Ju" 被解释为七月而不是六月。 </li>
<li>在所提供的日期中，如果所指定的星期几的值与按照该日期中剩余部分所确定的星期几的值不符合，那么该指定值就会被忽略。例如，尽管 1996 年 11 月 9 日实际上是星期五，"Tuesday November 9 1996" 也还是可以被接受并进行解析的。但是结果 date 对象中包含的是 "Friday November 9 1996"。 </li>
<li>JScript 处理所有的标准时区，以及全球标准时间 (UTC) 和格林威治标准时间 (GMT)。</li>
<li>小时、分钟、和秒钟之间用冒号分隔，尽管不是这三项都需要指明。"10:"、"10:11"、和 "10:11:12" 都是有效的。 </li>
<li>如果使用 24 小时计时的时钟，那么为中午 12 点之后的时间指定 "PM" 是错误的。例如 "23:15 PM" 就是错误的。</li>
<li>包含无效日期的字符串是错误的。例如，一个包含有两个年份或两个月份的字符串就是错误的。</li>
</ol>

 *
 * @returns {Date} 转换后的日期对象
 */

baidu.date.parse = function (source) {
  var reg = new RegExp("^\\d+(\\-|\\/)\\d+(\\-|\\/)\\d+\x24");
  if ('string' == typeof source) {
    if (reg.test(source) || isNaN(Date.parse(source))) {
      var d = source.split(/ |T/),
        d1 = d.length > 1 ? d[1].split(/[^\d]/) : [0, 0, 0],
        d0 = d[0].split(/[^\d]/);
      return new Date(d0[0] - 0,
        d0[1] - 1,
        d0[2] - 0,
        d1[0] - 0,
        d1[1] - 0,
        d1[2] - 0);
    } else {
      return new Date(source);
    }
  }

  return new Date();
};

/**
 * @namespace baidu.dom 操作dom的方法。
 */
baidu.dom = baidu.dom || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_NAME_ATTRS.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/2
 */




/**
 * 提供给setAttr与getAttr方法作名称转换使用
 * ie6,7下class要转换成className
 * @meta standard
 */

baidu.dom._NAME_ATTRS = (function () {
  var result = {
    'cellpadding': 'cellPadding',
    'cellspacing': 'cellSpacing',
    'colspan': 'colSpan',
    'rowspan': 'rowSpan',
    'valign': 'vAlign',
    'usemap': 'useMap',
    'frameborder': 'frameBorder'
  };

  if (baidu.browser.ie < 8) {
    result['for'] = 'htmlFor';
    result['class'] = 'className';
  } else {
    result.htmlFor = 'for';
    result.className = 'class';
  }

  return result;
})();
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */


/**
 * @namespace baidu.lang 对语言层面的封装，包括类型判断、模块扩展、继承基类以及对象自定义事件的支持。
*/
baidu.lang = baidu.lang || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/isString.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/30
 */



/**
 * 判断目标参数是否string类型或String对象
 * @name baidu.lang.isString
 * @function
 * @grammar baidu.lang.isString(source)
 * @param {Any} source 目标参数
 * @shortcut isString
 * @meta standard
 * @see baidu.lang.isObject,baidu.lang.isNumber,baidu.lang.isArray,baidu.lang.isElement,baidu.lang.isBoolean,baidu.lang.isDate
 *
 * @returns {boolean} 类型判断结果
 */
baidu.lang.isString = function (source) {
  return '[object String]' == Object.prototype.toString.call(source);
};

// 声明快捷方法
baidu.isString = baidu.lang.isString;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/g.js
 * author: allstar, erik, berg
 * version: 1.3
 * date: 2010-07-07
 */




/**
 * 从文档中获取指定的DOM元素
 * **内部方法**
 *
 * @param {string|HTMLElement} id 元素的id或DOM元素
 * @meta standard
 * @return {HTMLElement} DOM元素，如果不存在，返回null，如果参数不合法，直接返回参数
 */
baidu.dom._g = function (id) {
  if (baidu.lang.isString(id)) {
    return document.getElementById(id);
  }
  return id;
};

// 声明快捷方法
baidu._g = baidu.dom._g;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/g.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 从文档中获取指定的DOM元素
 * @name baidu.dom.g
 * @function
 * @grammar baidu.dom.g(id)
 * @param {string|HTMLElement} id 元素的id或DOM元素
 * @shortcut g,T.G
 * @meta standard
 * @see baidu.dom.q
 *
 * @returns {HTMLElement|null} 获取的元素，查找不到时返回null,如果参数不合法，直接返回参数
 */
baidu.dom.g = function (id) {
  if (!id) return null; //修改IE下baidu.dom.g(baidu.dom.g('dose_not_exist_id'))报错的bug，by Meizz, dengping
  if ('string' == typeof id || id instanceof String) {
    return document.getElementById(id);
  } else if (id && id.nodeName && (id.nodeType == 1 || id.nodeType == 9)) {
    return id;
  }
  return null;
};

// 声明快捷方法
baidu.get = baidu.g = baidu.G = baidu.dom.g;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_matchNode.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/18
 */




/**
 * 从目标元素指定的方向搜索元素
 *
 * @param {HTMLElement|string} element   目标元素或目标元素的id
 * @param {string}             direction 遍历的方向名称，取值为previousSibling,nextSibling
 * @param {string}             start     遍历的开始位置，取值为firstChild,lastChild,previousSibling,nextSibling
 * @meta standard
 * @return {HTMLElement} 搜索到的元素，如果没有找到，返回 null
 */
baidu.dom._matchNode = function (element, direction, start) {
  element = baidu.dom.g(element);

  for (var node = element[start]; node; node = node[direction]) {
    if (node.nodeType == 1) {
      return node;
    }
  }

  return null;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFilters.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 提供给setStyle与getStyle使用
 */
baidu.dom._styleFilter = baidu.dom._styleFilter || [];

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFilter/color.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 提供给setStyle与getStyle使用
 * @meta standard
 */
baidu.dom._styleFilter[baidu.dom._styleFilter.length] = {
  get: function (key, value) {
    if (/color/i.test(key) && value.indexOf("rgb(") != -1) {
      var array = value.split(",");

      value = "#";
      for (var i = 0, color; color = array[i]; i++) {
        color = parseInt(color.replace(/[^\d]/gi, ''), 10).toString(16);
        value += color.length == 1 ? "0" + color : color;
      }

      value = value.toUpperCase();
    }

    return value;
  }
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFilter/filter.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 为获取和设置样式的过滤器
 * @private
 * @meta standard
 */
baidu.dom._styleFilter.filter = function (key, value, method) {
  for (var i = 0, filters = baidu.dom._styleFilter, filter; filter = filters[i]; i++) {
    if (filter = filter[method]) {
      value = filter(key, value);
    }
  }

  return value;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFilter/px.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 提供给setStyle与getStyle使用
 * @meta standard
 */
baidu.dom._styleFilter[baidu.dom._styleFilter.length] = {
  set: function (key, value) {
    if (value.constructor == Number && !/zIndex|fontWeight|opacity|zoom|lineHeight/i.test(key)) {
      value = value + "px";
    }

    return value;
  }
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFixer.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 提供给setStyle与getStyle使用
 */
baidu.dom._styleFixer = baidu.dom._styleFixer || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFixer/display.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/24
 */





/**
 * 提供给setStyle与getStyle使用
 * @meta standard
 */
baidu.dom._styleFixer.display = baidu.browser.ie && baidu.browser.ie < 8 ? { // berg: 修改到<8，因为ie7同样存在这个问题，from 先伟
  set: function (element, value) {
    element = element.style;
    if (value == 'inline-block') {
      element.display = 'inline';
      element.zoom = 1;
    } else {
      element.display = value;
    }
  }
} : baidu.browser.firefox && baidu.browser.firefox < 3 ? {
  set: function (element, value) {
    element.style.display = value == 'inline-block' ? '-moz-inline-box' : value;
  }
} : null;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All right reserved.
 *
 * path: baidu/dom/_styleFixer/float.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 提供给setStyle与getStyle使用
 * @meta standard
 */
baidu.dom._styleFixer["float"] = baidu.browser.ie ? "styleFloat" : "cssFloat";
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/_styleFixer/opacity.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 获取目标元素指定元素className最近的祖先元素
 * @name baidu.dom.getAncestorByClass
 * @function
 * @grammar baidu.dom.getAncestorByClass(element, className)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} className 祖先元素的class，只支持单个class
 * @remark 使用者应保证提供的className合法性，不应包含不合法字符，className合法字符参考：http://www.w3.org/TR/CSS2/syndata.html。
 * @see baidu.dom.getAncestorBy,baidu.dom.getAncestorByTag
 *
 * @returns {HTMLElement|null} 指定元素className最近的祖先元素，查找不到时返回null
 */
baidu.dom.getAncestorByClass = function (element, className) {
  element = baidu.dom.g(element);
  className = new RegExp("(^|\\s)" + baidu.string.trim(className) + "(\\s|\x24)");

  while ((element = element.parentNode) && element.nodeType == 1) {
    if (className.test(element.className)) {
      return element;
    }
  }

  return null;
};

baidu.dom.getAncestorByTag = function (element, tagName) {
  element = baidu.dom.g(element);
  tagName = tagName.toUpperCase();

  while ((element = element.parentNode) && element.nodeType == 1) {
    if (element.tagName == tagName) {
      return element;
    }
  }

  return null;
};




/**
 * 提供给setStyle与getStyle使用
 * @meta standard
 */
baidu.dom._styleFixer.opacity = (baidu.browser.ie && baidu.browser.ie < 9) ? {
  get: function (element) {
    var filter = element.style.filter;
    return filter && filter.indexOf("opacity=") >= 0 ? (parseFloat(filter.match(/opacity=([^)]*)/)[1]) / 100) + "" : "1";
  },

  set: function (element, value) {
    var style = element.style;
    // 只能Quirks Mode下面生效??
    style.filter = (style.filter || "").replace(/alpha\([^\)]*\)/gi, "") + (value == 1 ? "" : "alpha(opacity=" + value * 100 + ")");
    // IE filters only apply to elements with "layout."
    style.zoom = 1;
  }
} : null;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */


/**
 * @namespace baidu.string 操作字符串的方法。
 */
baidu.string = baidu.string || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/trim.js
 * author: dron, erik
 * version: 1.1.0
 * date: 2009/11/15
 */



/**
 * 删除目标字符串两端的空白字符
 * @name baidu.string.trim
 * @function
 * @grammar baidu.string.trim(source)
 * @param {string} source 目标字符串
 * @remark
 * 不支持删除单侧空白字符
 * @shortcut trim
 * @meta standard
 *
 * @returns {string} 删除两端空白字符后的字符串
 */

(function () {
  var trimer = new RegExp("(^[\\s\\t\\xa0\\u3000]+)|([\\u3000\\xa0\\s\\t]+\x24)", "g");

  baidu.string.trim = function (source) {
    return String(source)
      .replace(trimer, "");
  };
})();

// 声明快捷方法
baidu.trim = baidu.string.trim;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All right reserved.
 *
 * path: baidu/dom/addClass.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/2
 */

/**
 * 去掉字符串中的html标签
 * @function
 * @grammar baidu.string.stripTags(source)
 * @param {string} source 要处理的字符串.
 * @return {String}
 */
baidu.string.stripTags = function (source) {
  return String(source || '').replace(/<[^>]+>/g, '');
};


/**
 * 为目标元素添加className
 * @name baidu.dom.addClass
 * @function
 * @grammar baidu.dom.addClass(element, className)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} className 要添加的className，允许同时添加多个class，中间使用空白符分隔
 * @remark
 * 使用者应保证提供的className合法性，不应包含不合法字符，className合法字符参考：http://www.w3.org/TR/CSS2/syndata.html。
 * @shortcut addClass
 * @meta standard
 * @see baidu.dom.removeClass
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.addClass = function (element, className) {
  element = baidu.dom.g(element);
  if (!element) {
    console.error("*** Error:addClass找不到元素", element, ",caller=", arguments.caller);
    return;
  }
  var classArray = className.split(/\s+/),
    result = element.className,
    classMatch = " " + result + " ",
    i = 0,
    l = classArray.length;

  for (; i < l; i++) {
    if (classMatch.indexOf(" " + classArray[i] + " ") < 0) {
      result += (result ? ' ' : '') + classArray[i];
    }
  }

  element.className = result;
  return element;
};

// 声明快捷方法
baidu.addClass = baidu.dom.addClass;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/children.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */




/**
 * 获取目标元素的直接子元素列表
 * @name baidu.dom.children
 * @function
 * @grammar baidu.dom.children(element)
 * @param {HTMLElement|String} element 目标元素或目标元素的id
 * @meta standard
 *
 * @returns {Array} 目标元素的子元素列表，没有子元素时返回空数组
 */
baidu.dom.children = function (element) {
  element = baidu.dom.g(element);

  for (var children = [], tmpEl = element.firstChild; tmpEl; tmpEl = tmpEl.nextSibling) {
    if (tmpEl.nodeType == 1) {
      children.push(tmpEl);
    }
  }

  return children;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/contains.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 判断一个元素是否包含另一个元素
 * @name baidu.dom.contains
 * @function
 * @grammar baidu.dom.contains(container, contained)
 * @param {HTMLElement|string} container 包含元素或元素的id
 * @param {HTMLElement|string} contained 被包含元素或元素的id
 * @meta standard
 * @see baidu.dom.intersect
 *
 * @returns {boolean} contained元素是否被包含于container元素的DOM节点上
 */
baidu.dom.contains = function (container, contained) {

  var g = baidu.dom._g;
  container = g(container);
  contained = g(contained);

  //fixme: 无法处理文本节点的情况(IE)
  return container.contains ? container != contained && container.contains(contained)
    : !!(container.compareDocumentPosition(contained) & 16);
};

/**
 * 查询一个元素是否包含指定的属性
 * @name baidu.dom.hasAttr
 * @function
 * @grammar baidu.dom.hasAttr(element, name)
 * @param {DOMElement|string} element DOM元素或元素的id
 * @param {string} name 要查找的属性名
 * @version 1.3
 *
 * @returns {Boolean} 是否包含此属性
 */

baidu.dom.hasAttr = function (element, name) {
  element = baidu.g(element);
  var attr = element.attributes.getNamedItem(name);
  return !!(attr && attr.specified);
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/setAttr.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */




/**
 * 设置目标元素的attribute值
 * @name baidu.dom.setAttr
 * @function
 * @grammar baidu.dom.setAttr(element, key, value)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} key 要设置的attribute键名
 * @param {string} value 要设置的attribute值
 * @remark
 *
            设置object的自定义属性时，由于浏览器限制，无法设置。

 * @shortcut setAttr
 * @meta standard
 * @see baidu.dom.getAttr,baidu.dom.setAttrs
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.setAttr = function (element, key, value) {
  element = baidu.dom.g(element);

  if ('style' == key) {
    element.style.cssText = value;
  } else {
    key = baidu.dom._NAME_ATTRS[key] || key;
    element.setAttribute(key, value);
  }

  return element;
};

// 声明快捷方法
baidu.setAttr = baidu.dom.setAttr;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/setAttrs.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */




/**
 * 批量设置目标元素的attribute值
 * @name baidu.dom.setAttrs
 * @function
 * @grammar baidu.dom.setAttrs(element, attributes)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {Object} attributes 要设置的attribute集合
 * @shortcut setAttrs
 * @meta standard
 * @see baidu.dom.setAttr,baidu.dom.getAttr
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.setAttrs = function (element, attributes) {
  element = baidu.dom.g(element);

  for (var key in attributes) {
    baidu.dom.setAttr(element, key, attributes[key]);
  }

  return element;
};

// 声明快捷方法
baidu.setAttrs = baidu.dom.setAttrs;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All right reserved.
 */


/**
 * 创建 Element 对象。
 * @author berg
 * @name baidu.dom.create
 * @function
 * @grammar baidu.dom.create(tagName[, options])
 * @param {string} tagName 标签名称.
 * @param {Object} opt_attributes 元素创建时拥有的属性，如style和className.
 * @version 1.3
 * @meta standard
 * @returns {HTMLElement} 创建的 Element 对象
 */
baidu.dom.create = function (tagName, opt_attributes) {
  var el = document.createElement(tagName),
    attributes = opt_attributes || {};
  return baidu.dom.setAttrs(el, attributes);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/first.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/11/18
 */



/**
 * 获取目标元素的第一个元素节点
 * @name baidu.dom.first
 * @function
 * @grammar baidu.dom.first(element)
 * @param {HTMLElement|String} element 目标元素或目标元素的id
 * @see baidu.dom.last,baidu.dom.prev,baidu.dom.next
 * @meta standard
 * @returns {HTMLElement|null} 目标元素的第一个元素节点，查找不到时返回null
 */
baidu.dom.first = function (element) {
  return baidu.dom._matchNode(element, 'nextSibling', 'firstChild');
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/getAttr.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */




/**
 * 获取目标元素的属性值
 * @name baidu.dom.getAttr
 * @function
 * @grammar baidu.dom.getAttr(element, key)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} key 要获取的attribute键名
 * @shortcut getAttr
 * @meta standard
 * @see baidu.dom.setAttr,baidu.dom.setAttrs
 *
 * @returns {string|null} 目标元素的attribute值，获取不到时返回null
 */
baidu.dom.getAttr = function (element, key) {
  element = baidu.dom.g(element);

  if ('style' == key) {
    return element.style.cssText;
  }

  key = baidu.dom._NAME_ATTRS[key] || key;
  return element.getAttribute(key);
};

// 声明快捷方法
baidu.getAttr = baidu.dom.getAttr;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/getDocument.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 获取目标元素所属的document对象
 * @name baidu.dom.getDocument
 * @function
 * @grammar baidu.dom.getDocument(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @meta standard
 * @see baidu.dom.getWindow
 *
 * @returns {HTMLDocument} 目标元素所属的document对象
 */
baidu.dom.getDocument = function (element) {
  element = baidu.dom.g(element);
  return element.nodeType == 9 ? element : element.ownerDocument || element.document;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */


/**
 * 获取目标元素所属的window对象
 * @name baidu.dom.getWindow
 * @function
 * @grammar baidu.dom.getWindow(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @see baidu.dom.getDocument
 *
 * @returns {window} 目标元素所属的window对象
 */
baidu.dom.getWindow = function (element) {
  element = baidu.dom.g(element);
  var doc = baidu.dom.getDocument(element);

  // 没有考虑版本低于safari2的情况
  // @see goog/dom/dom.js#goog.dom.DomHelper.prototype.getWindow
  return doc.parentWindow || doc.defaultView || null;
};


/**
 * 获取目标元素的computed style值。如果元素的样式值不能被浏览器计算，则会返回空字符串（IE）
 *
 * @author berg
 * @name baidu.dom.getComputedStyle
 * @function
 * @grammar baidu.dom.getComputedStyle(element, key)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} key 要获取的样式名
 *
 * @see baidu.dom.getStyle
 *
 * @returns {string} 目标元素的computed style值
 */

baidu.dom.getComputedStyle = function (element, key) {
  element = baidu.dom._g(element);
  var doc = baidu.dom.getDocument(element),
    styles;
  if (doc.defaultView && doc.defaultView.getComputedStyle) {
    styles = doc.defaultView.getComputedStyle(element, null);
    if (styles) {
      return styles[key] || styles.getPropertyValue(key);
    }
  }
  return '';
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/toCamelCase.js
 * author: erik, berg
 * version: 1.2
 * date: 2010-06-22
 */



/**
 * 将目标字符串进行驼峰化处理
 * @name baidu.string.toCamelCase
 * @function
 * @grammar baidu.string.toCamelCase(source)
 * @param {string} source 目标字符串
 * @remark
 * 支持单词以“-_”分隔
 * @meta standard
 *
 * @returns {string} 驼峰化处理后的字符串
 */

//todo:考虑以后去掉下划线支持？
baidu.string.toCamelCase = function (source) {
  //提前判断，提高getStyle等的效率 thanks xianwei
  if (source.indexOf('-') < 0 && source.indexOf('_') < 0) {
    return source;
  }
  return source.replace(/[-_][^-_]/g, function (match) {
    return match.charAt(1).toUpperCase();
  });
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */







/**
 * 获取目标元素的样式值
 * @name baidu.dom.getStyle
 * @function
 * @grammar baidu.dom.getStyle(element, key)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} key 要获取的样式名
 * @remark
 *
 * 为了精简代码，本模块默认不对任何浏览器返回值进行归一化处理（如使用getStyle时，不同浏览器下可能返回rgb颜色或hex颜色），也不会修复浏览器的bug和差异性（如设置IE的float属性叫styleFloat，firefox则是cssFloat）。<br />
 * baidu.dom._styleFixer和baidu.dom._styleFilter可以为本模块提供支持。<br />
 * 其中_styleFilter能对颜色和px进行归一化处理，_styleFixer能对display，float，opacity，textOverflow的浏览器兼容性bug进行处理。
 * @shortcut getStyle
 * @meta standard
 * @see baidu.dom.setStyle,baidu.dom.setStyles, baidu.dom.getComputedStyle
 *
 * @returns {string} 目标元素的样式值
 */
// TODO
// 1. 无法解决px/em单位统一的问题（IE）
// 2. 无法解决样式值为非数字值的情况（medium等 IE）
baidu.dom.getStyle = function (element, key) {
  var dom = baidu.dom;

  element = dom.g(element);
  key = baidu.string.toCamelCase(key);
  //computed style, then cascaded style, then explicitly set style.
  var value = element.style[key] ||
    (element.currentStyle ? element.currentStyle[key] : "") ||
    dom.getComputedStyle(element, key);

  // 在取不到值的时候，用fixer进行修正
  if (!value) {
    var fixer = dom._styleFixer[key];
    if (fixer) {
      value = fixer.get ? fixer.get(element) : baidu.dom.getStyle(element, fixer);
    }
  }

  /* 检查结果过滤器 */
  if (fixer = dom._styleFilter) {
    value = fixer.filter(key, value, 'get');
  }

  return value;
};

// 声明快捷方法
baidu.getStyle = baidu.dom.getStyle;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/getPosition.js
 * author: berg
 * version: 1.2.0
 * date: 2010/12/16
 *
 * thanks google closure & jquery
 * 本函数部分思想来自：http://code.google.com/p/doctype/wiki/ArticlePageOffset
 */










/**
 * 获取目标元素相对于整个文档左上角的位置
 * @name baidu.dom.getPosition
 * @function
 * @grammar baidu.dom.getPosition(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @meta standard
 *
 * @returns {Object} 目标元素的位置，键值为top和left的Object。
 */
baidu.dom.getPosition = function (element) {
  element = baidu.dom.g(element);
  var doc = baidu.dom.getDocument(element),
    browser = baidu.browser,
    getStyle = baidu.dom.getStyle,
    // Gecko 1.9版本以下用getBoxObjectFor计算位置
    // 但是某些情况下是有bug的
    // 对于这些有bug的情况
    // 使用递归查找的方式
    BUGGY_GECKO_BOX_OBJECT = browser.isGecko > 0 &&
      doc.getBoxObjectFor &&
      getStyle(element, 'position') == 'absolute' &&
      (element.style.top === '' || element.style.left === ''),
    pos = { "left": 0, "top": 0 },
    viewport = (browser.ie && !browser.isStrict) ? doc.body : doc.documentElement,
    parent,
    box;

  if (element == viewport) {
    return pos;
  }


  if (element.getBoundingClientRect) { // IE and Gecko 1.9+

    //当HTML或者BODY有border width时, 原生的getBoundingClientRect返回值是不符合预期的
    //考虑到通常情况下 HTML和BODY的border只会设成0px,所以忽略该问题.
    box = element.getBoundingClientRect();
    pos.left = Math.floor(box.left) + Math.max(doc.documentElement.scrollLeft, doc.body.scrollLeft);
    pos.top = Math.floor(box.top) + Math.max(doc.documentElement.scrollTop, doc.body.scrollTop);

    // IE会给HTML元素添加一个border，默认是medium（2px）
    // 但是在IE 6 7 的怪异模式下，可以被html { border: 0; } 这条css规则覆盖
    // 在IE7的标准模式下，border永远是2px，这个值通过clientLeft 和 clientTop取得
    // 但是。。。在IE 6 7的怪异模式，如果用户使用css覆盖了默认的medium
    // clientTop和clientLeft不会更新
    pos.left -= doc.documentElement.clientLeft;
    pos.top -= doc.documentElement.clientTop;

    var htmlDom = doc.body,
      // 在这里，不使用element.style.borderLeftWidth，只有computedStyle是可信的
      htmlBorderLeftWidth = parseInt(getStyle(htmlDom, 'borderLeftWidth'), 10),
      htmlBorderTopWidth = parseInt(getStyle(htmlDom, 'borderTopWidth'), 10);
    if (browser.ie && !browser.isStrict) {
      pos.left -= isNaN(htmlBorderLeftWidth) ? 2 : htmlBorderLeftWidth;
      pos.top -= isNaN(htmlBorderTopWidth) ? 2 : htmlBorderTopWidth;
    }
    /*
     * 因为firefox 3.6和4.0在特定页面下(场景待补充)都会出现1px偏移,所以暂时移除该逻辑分支
     * 如果 2.0版本时firefox仍存在问题,该逻辑分支将彻底移除. by rocy 2011-01-20
    } else if (doc.getBoxObjectFor && !BUGGY_GECKO_BOX_OBJECT){ // gecko 1.9-

        // 1.9以下的Gecko，会忽略ancestors的scroll值
        // https://bugzilla.mozilla.org/show_bug.cgi?id=328881 and
        // https://bugzilla.mozilla.org/show_bug.cgi?id=330619

        box = doc.getBoxObjectFor(element);
        var vpBox = doc.getBoxObjectFor(viewport);
        pos.left = box.screenX - vpBox.screenX;
        pos.top  = box.screenY - vpBox.screenY;
        */
  } else { // safari/opera/firefox
    parent = element;

    do {
      pos.left += parent.offsetLeft;
      pos.top += parent.offsetTop;

      // safari里面，如果遍历到了一个fixed的元素，后面的offset都不准了
      if (browser.isWebkit > 0 && getStyle(parent, 'position') == 'fixed') {
        pos.left += doc.body.scrollLeft;
        pos.top += doc.body.scrollTop;
        break;
      }

      parent = parent.offsetParent;
    } while (parent && parent != element);

    // 对body offsetTop的修正
    if (browser.opera > 0 || (browser.isWebkit > 0 && getStyle(element, 'position') == 'absolute')) {
      pos.top -= doc.body.offsetTop;
    }

    // 计算除了body的scroll
    parent = element.offsetParent;
    while (parent && parent != doc.body) {
      pos.left -= parent.scrollLeft;
      // see https://bugs.opera.com/show_bug.cgi?id=249965
      //            if (!b.opera || parent.tagName != 'TR') {
      if (!browser.opera || parent.tagName != 'TR') {
        pos.top -= parent.scrollTop;
      }
      parent = parent.offsetParent;
    }
  }

  return pos;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/hasClass.js
 * author: berg
 * version: 1.0
 * date: 2010-07-06
 */






/**
 * 判断元素是否拥有指定的className
 * @name baidu.dom.hasClass
 * @function
 * @grammar baidu.dom.hasClass(element, className)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} className 要判断的className，可以是用空格拼接的多个className
 * @version 1.2
 * @remark
 * 对于参数className，支持空格分隔的多个className
 * @see baidu.dom.addClass, baidu.dom.removeClass
 * @meta standard
 * @returns {Boolean} 是否拥有指定的className，如果要查询的classname有一个或多个不在元素的className中，返回false
 */
baidu.dom.hasClass = function (element, className) {
  element = baidu.dom.g(element);
  var classArray = baidu.string.trim(className).split(/\s+/),
    len = classArray.length;

  className = element.className.split(/\s+/).join(" ");

  while (len--) {
    if (!(new RegExp("(^| )" + classArray[len] + "( |\x24)")).test(className)) {
      return false;
    }
  }
  return true;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/hide.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 隐藏目标元素
 * @name baidu.dom.hide
 * @function
 * @grammar baidu.dom.hide(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @shortcut hide
 * @meta standard
 * @see baidu.dom.show,baidu.dom.toggle
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.hide = function (element) {
  element = baidu.dom.g(element);
  if (element) element.style.display = "none";

  return element;
};

// 声明快捷方法
baidu.hide = baidu.dom.hide;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/insertAfter.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * 将目标元素添加到基准元素之后
 * @name baidu.dom.insertAfter
 * @function
 * @grammar baidu.dom.insertAfter(newElement, existElement)
 * @param {HTMLElement|string} newElement 被添加的目标元素
 * @param {HTMLElement|string} existElement 基准元素
 * @meta standard
 * @see baidu.dom.insertBefore
 *
 * @returns {HTMLElement} 被添加的目标元素
 */
baidu.dom.insertAfter = function (newElement, existElement) {
  var g, existParent;
  g = baidu.dom._g;
  newElement = g(newElement);
  existElement = g(existElement);
  if (existElement) existParent = existElement.parentNode;

  if (existParent) {
    existParent.insertBefore(newElement, existElement.nextSibling);
  }
  return newElement;
};
/**
 * 在元素内插入一dom,套住元素内以前所有的dom
 * @param newElement
 * @param parentElement
 */
baidu.dom.insertInner = function (newElement, parentElement) {
  var g, existParent;
  g = baidu.dom._g;
  newElement = g(newElement);
  parentElement = g(parentElement);
  if (parentElement) {
    /*T.each(T.dom.children( parentElement ), function(item){
      newElement.appendChild( item );
    });*/
    var html = parentElement.innerHTML;
    parentElement.innerHTML = "";
    parentElement.appendChild(newElement);
    newElement.innerHTML = html;
  }
  return newElement;
};
//add by wangxk
baidu.dom.insertInnerBefore = function (newElement, parentElement) {
  var g, existParent;
  g = baidu.dom._g;
  newElement = g(newElement);
  parentElement = g(parentElement);
  newElement = newElement[0] || newElement;
  parentElement = parentElement[0] || parentElement;
  if (!parentElement) {
    return newElement;
  } else {
    if (T.dom.children(parentElement).length > 0) {
      baidu.dom.insertBefore(newElement, T.dom.children(parentElement)[0]);
    } else {
      return parentElement.appendChild(newElement);
    }
  }
  return newElement;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/insertBefore.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 将目标元素添加到基准元素之前
 * @name baidu.dom.insertBefore
 * @function
 * @grammar baidu.dom.insertBefore(newElement, existElement)
 * @param {HTMLElement|string} newElement 被添加的目标元素
 * @param {HTMLElement|string} existElement 基准元素
 * @meta standard
 * @see baidu.dom.insertAfter
 *
 * @returns {HTMLElement} 被添加的目标元素
 */
baidu.dom.insertBefore = function (newElement, existElement) {
  var g, existParent;
  g = baidu.dom._g;
  newElement = g(newElement);
  existElement = g(existElement);
  if (existElement) existParent = existElement.parentNode;

  if (existParent) {
    existParent.insertBefore(newElement, existElement);
  }

  return newElement;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */




/**
 * 在目标元素的指定位置插入HTML代码
 * @name baidu.dom.insertHTML
 * @function
 * @grammar baidu.dom.insertHTML(element, position, html)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} position 插入html的位置信息，取值为beforeBegin,afterBegin,beforeEnd,afterEnd
 * @param {string} html 要插入的html
 * @remark
 *
 * 对于position参数，大小写不敏感<br>
 * 参数的意思：beforeBegin&lt;span&gt;afterBegin   this is span! beforeEnd&lt;/span&gt; afterEnd <br />
 * 此外，如果使用本函数插入带有script标签的HTML字符串，script标签对应的脚本将不会被执行。
 *
 * @shortcut insertHTML
 * @meta standard
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.insertHTML = function (element, position, html) {
  element = baidu.dom.g(element);
  var range, begin;

  //在opera中insertAdjacentHTML方法实现不标准，如果DOMNodeInserted方法被监听则无法一次插入多element
  //by lixiaopeng @ 2011-8-19
  if (element.insertAdjacentHTML && !baidu.browser.opera) {
    element.insertAdjacentHTML(position, html);
  } else {
    // 这里不做"undefined" != typeof(HTMLElement) && !window.opera判断，其它浏览器将出错？！
    // 但是其实做了判断，其它浏览器下等于这个函数就不能执行了
    range = element.ownerDocument.createRange();
    // FF下range的位置设置错误可能导致创建出来的fragment在插入dom树之后html结构乱掉
    // 改用range.insertNode来插入html, by wenyuxiang @ 2010-12-14.
    position = position.toUpperCase();
    if (position == 'AFTERBEGIN' || position == 'BEFOREEND') {
      range.selectNodeContents(element);
      range.collapse(position == 'AFTERBEGIN');
    } else {
      begin = position == 'BEFOREBEGIN';
      range[begin ? 'setStartBefore' : 'setEndAfter'](element);
      range.collapse(begin);
    }
    range.insertNode(range.createContextualFragment(html));
  }
  return element;
};

baidu.insertHTML = baidu.dom.insertHTML;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/next.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/18
 */



/**
 * 获取目标元素的下一个兄弟元素节点
 * @name baidu.dom.next
 * @function
 * @grammar baidu.dom.next(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @see baidu.dom.first,baidu.dom.last,baidu.dom.prev
 * @meta standard
 * @returns {HTMLElement|null} 目标元素的下一个兄弟元素节点，查找不到时返回null
 */
baidu.dom.next = function (element) {
  return baidu.dom._matchNode(element, 'nextSibling', 'nextSibling');
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/escapeReg.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */


/**
* 获取目标元素的上一个兄弟元素节点
* @name baidu.dom.prev
* @function
* @grammar baidu.dom.prev(element)
* @param {HTMLElement|string} element 目标元素或目标元素的id
* @see baidu.dom.first,baidu.dom.last,baidu.dom.next
*
*
* @returns {HTMLElement|null} 目标元素的上一个兄弟元素节点，查找不到时返回null
*/
baidu.dom.prev = function (element) {
  return baidu.dom._matchNode(element, 'previousSibling', 'previousSibling');
};



/**
 * 将目标字符串中可能会影响正则表达式构造的字符串进行转义。
 * @name baidu.string.escapeReg
 * @function
 * @grammar baidu.string.escapeReg(source)
 * @param {string} source 目标字符串
 * @remark
 * 给以下字符前加上“\”进行转义：.*+?^=!:${}()|[]/\
 * @meta standard
 *
 * @returns {string} 转义后的字符串
 */
baidu.string.escapeReg = function (source) {
  return String(source)
    .replace(new RegExp("([.*+?^=!:\x24{}()|[\\]\/\\\\])", "g"), '\\\x241');
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/q.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */





/**
 * 通过className获取元素
 * @name baidu.dom.q
 * @function
 * @grammar baidu.dom.q(className[, element, tagName])
 * @param {string} className 元素的class，只能指定单一的class，如果为空字符串或者纯空白的字符串，返回空数组。
 * @param {string|HTMLElement} [element] 开始搜索的元素，默认是document。
 * @param {string} [tagName] 要获取元素的标签名，如果没有值或者值为空字符串或者纯空白的字符串，表示不限制标签名。
 * @remark 不保证返回数组中DOM节点的顺序和文档中DOM节点的顺序一致。
 * @shortcut q,T.Q
 * @meta standard
 * @see baidu.dom.g
 *
 * @returns {Array} 获取的元素集合，查找不到或className参数错误时返回空数组.
 */
baidu.dom.q = function (className, element, tagName) {
  var result = [],
    trim = baidu.string.trim,
    len, i, elements, node;

  if (!(className = trim(className))) {
    return result;
  }

  // 初始化element参数
  if ('undefined' == typeof element) {
    element = document;
  } else {
    element = baidu.dom.g(element);
    if (!element) {
      return result;
    }
  }

  // 初始化tagName参数
  tagName && (tagName = trim(tagName).toUpperCase());

  // 查询元素
  if (element.getElementsByClassName) {
    elements = element.getElementsByClassName(className);
    len = elements.length;
    for (i = 0; i < len; i++) {
      node = elements[i];
      if (tagName && node.tagName != tagName) {
        continue;
      }
      result[result.length] = node;
    }
  } else {
    className = new RegExp("(^|\\s)" + baidu.string.escapeReg(className) + "(\\s|\x24)");
    elements = tagName ? element.getElementsByTagName(tagName) : (element.all || element.getElementsByTagName("*"));
    len = elements.length;
    for (i = 0; i < len; i++) {
      node = elements[i];
      className.test(node.className) && (result[result.length] = node);
    }
  }

  return result;
};

// 声明快捷方法
baidu.q = baidu.Q = baidu.dom.q;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/*!
 * Sizzle CSS Selector Engine
 *  Copyright 2011, The Dojo Foundation
 *  Released under the MIT, BSD, and GPL Licenses.
 *  More information: http://sizzlejs.com/
 */


/**
 * 提供css选择器功能   选择器支持所有的<a href="http://www.w3.org/TR/css3-selectors/">css3选择器</a> ，核心实现采用sizzle。baidu.dom.query.matches 请参考<a href="http://wiki.github.com/jeresig/sizzle/" target="_blank">sizzle 文档</a>
 * @name baidu.dom.query
 * @function
 * @grammar baidu.dom.query(selector[, context, results])
 * @param {String} selector 选择器定义
 * @param {HTMLElement | DOMDocument} [context] 查找的上下文
 * @param {Array} [results] 查找的结果会追加到这个数组中
 * @version 1.5
 * @remark
 *
            选择器支持所有的<a href="http://www.w3.org/TR/css3-selectors/">css3选择器</a> ，核心实现采用sizzle。可参考<a href="https://github.com/jquery/sizzle/wiki/Sizzle-Home" target="_blank">sizzle 文档</a>

 * @see baidu.dom.g, baidu.dom.q,
 * @returns {Array}        包含所有筛选出的DOM元素的数组
 */

(function () {

  var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
    expando = "sizcache" + (Math.random() + '').replace('.', ''),
    done = 0,
    toString = Object.prototype.toString,
    hasDuplicate = false,
    baseHasDuplicate = true,
    rBackslash = /\\/g,
    rReturn = /\r\n/g,
    rNonWord = /\W/;

  // Here we check if the JavaScript engine is using some sort of
  // optimization where it does not always call our comparision
  // function. If that is the case, discard the hasDuplicate value.
  //   Thus far that includes Google Chrome.
  [0, 0].sort(function () {
    baseHasDuplicate = false;
    return 0;
  });

  var Sizzle = function (selector, context, results, seed) {
    results = results || [];
    context = context || document;

    var origContext = context;

    if (context.nodeType !== 1 && context.nodeType !== 9) {
      return [];
    }

    if (!selector || typeof selector !== "string") {
      return results;
    }

    var m, set, checkSet, extra, ret, cur, pop, i,
      prune = true,
      contextXML = Sizzle.isXML(context),
      parts = [],
      soFar = selector;

    // Reset the position of the chunker regexp (start from head)
    do {
      chunker.exec("");
      m = chunker.exec(soFar);

      if (m) {
        soFar = m[3];

        parts.push(m[1]);

        if (m[2]) {
          extra = m[3];
          break;
        }
      }
    } while (m);

    if (parts.length > 1 && origPOS.exec(selector)) {

      if (parts.length === 2 && Expr.relative[parts[0]]) {
        set = posProcess(parts[0] + parts[1], context, seed);

      } else {
        set = Expr.relative[parts[0]] ?
          [context] :
          Sizzle(parts.shift(), context);

        while (parts.length) {
          selector = parts.shift();

          if (Expr.relative[selector]) {
            selector += parts.shift();
          }

          set = posProcess(selector, set, seed);
        }
      }

    } else {
      // Take a shortcut and set the context if the root selector is an ID
      // (but not if it'll be faster if the inner selector is an ID)
      if (!seed && parts.length > 1 && context.nodeType === 9 && !contextXML &&
        Expr.match.ID.test(parts[0]) && !Expr.match.ID.test(parts[parts.length - 1])) {

        ret = Sizzle.find(parts.shift(), context, contextXML);
        context = ret.expr ?
          Sizzle.filter(ret.expr, ret.set)[0] :
          ret.set[0];
      }

      if (context) {
        ret = seed ?
          { expr: parts.pop(), set: makeArray(seed) } :
          Sizzle.find(parts.pop(), parts.length === 1 && (parts[0] === "~" || parts[0] === "+") && context.parentNode ? context.parentNode : context, contextXML);

        set = ret.expr ?
          Sizzle.filter(ret.expr, ret.set) :
          ret.set;

        if (parts.length > 0) {
          checkSet = makeArray(set);

        } else {
          prune = false;
        }

        while (parts.length) {
          cur = parts.pop();
          pop = cur;

          if (!Expr.relative[cur]) {
            cur = "";
          } else {
            pop = parts.pop();
          }

          if (pop === null) {
            pop = context;
          }

          Expr.relative[cur](checkSet, pop, contextXML);
        }

      } else {
        checkSet = parts = [];
      }
    }

    if (!checkSet) {
      checkSet = set;
    }

    if (!checkSet) {
      Sizzle.error(cur || selector);
    }

    if (toString.call(checkSet) === "[object Array]") {
      if (!prune) {
        results.push.apply(results, checkSet);

      } else if (context && context.nodeType === 1) {
        for (i = 0; checkSet[i] != null; i++) {
          if (checkSet[i] && (checkSet[i] === true || checkSet[i].nodeType === 1 && Sizzle.contains(context, checkSet[i]))) {
            results.push(set[i]);
          }
        }

      } else {
        for (i = 0; checkSet[i] != null; i++) {
          if (checkSet[i] && checkSet[i].nodeType === 1) {
            results.push(set[i]);
          }
        }
      }

    } else {
      makeArray(checkSet, results);
    }

    if (extra) {
      Sizzle(extra, origContext, results, seed);
      Sizzle.uniqueSort(results);
    }

    return results;
  };

  Sizzle.uniqueSort = function (results) {
    if (sortOrder) {
      hasDuplicate = baseHasDuplicate;
      results.sort(sortOrder);

      if (hasDuplicate) {
        for (var i = 1; i < results.length; i++) {
          if (results[i] === results[i - 1]) {
            results.splice(i--, 1);
          }
        }
      }
    }

    return results;
  };

  Sizzle.matches = function (expr, set) {
    return Sizzle(expr, null, null, set);
  };

  Sizzle.matchesSelector = function (node, expr) {
    return Sizzle(expr, null, null, [node]).length > 0;
  };

  Sizzle.find = function (expr, context, isXML) {
    var set, i, len, match, type, left;

    if (!expr) {
      return [];
    }

    for (i = 0, len = Expr.order.length; i < len; i++) {
      type = Expr.order[i];

      if ((match = Expr.leftMatch[type].exec(expr))) {
        left = match[1];
        match.splice(1, 1);

        if (left.substr(left.length - 1) !== "\\") {
          match[1] = (match[1] || "").replace(rBackslash, "");
          set = Expr.find[type](match, context, isXML);

          if (set != null) {
            expr = expr.replace(Expr.match[type], "");
            break;
          }
        }
      }
    }

    if (!set) {
      set = typeof context.getElementsByTagName !== "undefined" ?
        context.getElementsByTagName("*") :
        [];
    }

    return { set: set, expr: expr };
  };

  Sizzle.filter = function (expr, set, inplace, not) {
    var match, anyFound,
      type, found, item, filter, left,
      i, pass,
      old = expr,
      result = [],
      curLoop = set,
      isXMLFilter = set && set[0] && Sizzle.isXML(set[0]);

    while (expr && set.length) {
      for (type in Expr.filter) {
        if ((match = Expr.leftMatch[type].exec(expr)) != null && match[2]) {
          filter = Expr.filter[type];
          left = match[1];

          anyFound = false;

          match.splice(1, 1);

          if (left.substr(left.length - 1) === "\\") {
            continue;
          }

          if (curLoop === result) {
            result = [];
          }

          if (Expr.preFilter[type]) {
            match = Expr.preFilter[type](match, curLoop, inplace, result, not, isXMLFilter);

            if (!match) {
              anyFound = found = true;

            } else if (match === true) {
              continue;
            }
          }

          if (match) {
            for (i = 0; (item = curLoop[i]) != null; i++) {
              if (item) {
                found = filter(item, match, i, curLoop);
                pass = not ^ found;

                if (inplace && found != null) {
                  if (pass) {
                    anyFound = true;

                  } else {
                    curLoop[i] = false;
                  }

                } else if (pass) {
                  result.push(item);
                  anyFound = true;
                }
              }
            }
          }

          if (found !== undefined) {
            if (!inplace) {
              curLoop = result;
            }

            expr = expr.replace(Expr.match[type], "");

            if (!anyFound) {
              return [];
            }

            break;
          }
        }
      }

      // Improper expression
      if (expr === old) {
        if (anyFound == null) {
          Sizzle.error(expr);

        } else {
          break;
        }
      }

      old = expr;
    }

    return curLoop;
  };

  Sizzle.error = function (msg) {
    throw "Syntax error, unrecognized expression: " + msg;
  };

  /**
   * Utility function for retreiving the text value of an array of DOM nodes
   * @param {Array|Element} elem
   */
  var getText = Sizzle.getText = function (elem) {
    var i, node,
      nodeType = elem.nodeType,
      ret = "";

    if (nodeType) {
      if (nodeType === 1) {
        // Use textContent || innerText for elements
        if (typeof elem.textContent === 'string') {
          return elem.textContent;
        } else if (typeof elem.innerText === 'string') {
          // Replace IE's carriage returns
          return elem.innerText.replace(rReturn, '');
        } else {
          // Traverse it's children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }
    } else {

      // If no nodeType, this is expected to be an array
      for (i = 0; (node = elem[i]); i++) {
        // Do not traverse comment nodes
        if (node.nodeType !== 8) {
          ret += getText(node);
        }
      }
    }
    return ret;
  };

  var Expr = Sizzle.selectors = {
    order: ["ID", "NAME", "TAG"],

    match: {
      ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
      CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
      NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,
      ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,
      TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,
      CHILD: /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,
      POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,
      PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/
    },

    leftMatch: {},

    attrMap: {
      "class": "className",
      "for": "htmlFor"
    },

    attrHandle: {
      href: function (elem) {
        return elem.getAttribute("href");
      },
      type: function (elem) {
        return elem.getAttribute("type");
      }
    },

    relative: {
      "+": function (checkSet, part) {
        var isPartStr = typeof part === "string",
          isTag = isPartStr && !rNonWord.test(part),
          isPartStrNotTag = isPartStr && !isTag;

        if (isTag) {
          part = part.toLowerCase();
        }

        for (var i = 0, l = checkSet.length, elem; i < l; i++) {
          if ((elem = checkSet[i])) {
            while ((elem = elem.previousSibling) && elem.nodeType !== 1) { }

            checkSet[i] = isPartStrNotTag || elem && elem.nodeName.toLowerCase() === part ?
              elem || false :
              elem === part;
          }
        }

        if (isPartStrNotTag) {
          Sizzle.filter(part, checkSet, true);
        }
      },

      ">": function (checkSet, part) {
        var elem,
          isPartStr = typeof part === "string",
          i = 0,
          l = checkSet.length;

        if (isPartStr && !rNonWord.test(part)) {
          part = part.toLowerCase();

          for (; i < l; i++) {
            elem = checkSet[i];

            if (elem) {
              var parent = elem.parentNode;
              checkSet[i] = parent.nodeName.toLowerCase() === part ? parent : false;
            }
          }

        } else {
          for (; i < l; i++) {
            elem = checkSet[i];

            if (elem) {
              checkSet[i] = isPartStr ?
                elem.parentNode :
                elem.parentNode === part;
            }
          }

          if (isPartStr) {
            Sizzle.filter(part, checkSet, true);
          }
        }
      },

      "": function (checkSet, part, isXML) {
        var nodeCheck,
          doneName = done++,
          checkFn = dirCheck;

        if (typeof part === "string" && !rNonWord.test(part)) {
          part = part.toLowerCase();
          nodeCheck = part;
          checkFn = dirNodeCheck;
        }

        checkFn("parentNode", part, doneName, checkSet, nodeCheck, isXML);
      },

      "~": function (checkSet, part, isXML) {
        var nodeCheck,
          doneName = done++,
          checkFn = dirCheck;

        if (typeof part === "string" && !rNonWord.test(part)) {
          part = part.toLowerCase();
          nodeCheck = part;
          checkFn = dirNodeCheck;
        }

        checkFn("previousSibling", part, doneName, checkSet, nodeCheck, isXML);
      }
    },

    find: {
      ID: function (match, context, isXML) {
        if (typeof context.getElementById !== "undefined" && !isXML) {
          var m = context.getElementById(match[1]);
          // Check parentNode to catch when Blackberry 4.6 returns
          // nodes that are no longer in the document #6963
          return m && m.parentNode ? [m] : [];
        }
      },

      NAME: function (match, context) {
        if (typeof context.getElementsByName !== "undefined") {
          var ret = [],
            results = context.getElementsByName(match[1]);

          for (var i = 0, l = results.length; i < l; i++) {
            if (results[i].getAttribute("name") === match[1]) {
              ret.push(results[i]);
            }
          }

          return ret.length === 0 ? null : ret;
        }
      },

      TAG: function (match, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(match[1]);
        }
      }
    },
    preFilter: {
      CLASS: function (match, curLoop, inplace, result, not, isXML) {
        match = " " + match[1].replace(rBackslash, "") + " ";

        if (isXML) {
          return match;
        }

        for (var i = 0, elem; (elem = curLoop[i]) != null; i++) {
          if (elem) {
            if (not ^ (elem.className && (" " + elem.className + " ").replace(/[\t\n\r]/g, " ").indexOf(match) >= 0)) {
              if (!inplace) {
                result.push(elem);
              }

            } else if (inplace) {
              curLoop[i] = false;
            }
          }
        }

        return false;
      },

      ID: function (match) {
        return match[1].replace(rBackslash, "");
      },

      TAG: function (match, curLoop) {
        return match[1].replace(rBackslash, "").toLowerCase();
      },

      CHILD: function (match) {
        if (match[1] === "nth") {
          if (!match[2]) {
            Sizzle.error(match[0]);
          }

          match[2] = match[2].replace(/^\+|\s*/g, '');

          // parse equations like 'even', 'odd', '5', '2n', '3n+2', '4n-1', '-n+6'
          var test = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec(
            match[2] === "even" && "2n" || match[2] === "odd" && "2n+1" ||
            !/\D/.test(match[2]) && "0n+" + match[2] || match[2]);

          // calculate the numbers (first)n+(last) including if they are negative
          match[2] = (test[1] + (test[2] || 1)) - 0;
          match[3] = test[3] - 0;
        }
        else if (match[2]) {
          Sizzle.error(match[0]);
        }

        // TODO: Move to normal caching system
        match[0] = done++;

        return match;
      },

      ATTR: function (match, curLoop, inplace, result, not, isXML) {
        var name = match[1] = match[1].replace(rBackslash, "");

        if (!isXML && Expr.attrMap[name]) {
          match[1] = Expr.attrMap[name];
        }

        // Handle if an un-quoted value was used
        match[4] = (match[4] || match[5] || "").replace(rBackslash, "");

        if (match[2] === "~=") {
          match[4] = " " + match[4] + " ";
        }

        return match;
      },

      PSEUDO: function (match, curLoop, inplace, result, not) {
        if (match[1] === "not") {
          // If we're dealing with a complex expression, or a simple one
          if ((chunker.exec(match[3]) || "").length > 1 || /^\w/.test(match[3])) {
            match[3] = Sizzle(match[3], null, null, curLoop);

          } else {
            var ret = Sizzle.filter(match[3], curLoop, inplace, true ^ not);

            if (!inplace) {
              result.push.apply(result, ret);
            }

            return false;
          }

        } else if (Expr.match.POS.test(match[0]) || Expr.match.CHILD.test(match[0])) {
          return true;
        }

        return match;
      },

      POS: function (match) {
        match.unshift(true);

        return match;
      }
    },

    filters: {
      enabled: function (elem) {
        return elem.disabled === false && elem.type !== "hidden";
      },

      disabled: function (elem) {
        return elem.disabled === true;
      },

      checked: function (elem) {
        return elem.checked === true;
      },

      selected: function (elem) {
        // Accessing this property makes selected-by-default
        // options in Safari work properly
        if (elem.parentNode) {
          elem.parentNode.selectedIndex;
        }

        return elem.selected === true;
      },

      parent: function (elem) {
        return !!elem.firstChild;
      },

      empty: function (elem) {
        return !elem.firstChild;
      },

      has: function (elem, i, match) {
        return !!Sizzle(match[3], elem).length;
      },

      header: function (elem) {
        return (/h\d/i).test(elem.nodeName);
      },

      text: function (elem) {
        var attr = elem.getAttribute("type"), type = elem.type;
        // IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)
        // use getAttribute instead to test this case
        return elem.nodeName.toLowerCase() === "input" && "text" === type && (attr === type || attr === null);
      },

      radio: function (elem) {
        return elem.nodeName.toLowerCase() === "input" && "radio" === elem.type;
      },

      checkbox: function (elem) {
        return elem.nodeName.toLowerCase() === "input" && "checkbox" === elem.type;
      },

      file: function (elem) {
        return elem.nodeName.toLowerCase() === "input" && "file" === elem.type;
      },

      password: function (elem) {
        return elem.nodeName.toLowerCase() === "input" && "password" === elem.type;
      },

      submit: function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && "submit" === elem.type;
      },

      image: function (elem) {
        return elem.nodeName.toLowerCase() === "input" && "image" === elem.type;
      },

      reset: function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && "reset" === elem.type;
      },

      button: function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && "button" === elem.type || name === "button";
      },

      input: function (elem) {
        return (/input|select|textarea|button/i).test(elem.nodeName);
      },

      focus: function (elem) {
        return elem === elem.ownerDocument.activeElement;
      }
    },
    setFilters: {
      first: function (elem, i) {
        return i === 0;
      },

      last: function (elem, i, match, array) {
        return i === array.length - 1;
      },

      even: function (elem, i) {
        return i % 2 === 0;
      },

      odd: function (elem, i) {
        return i % 2 === 1;
      },

      lt: function (elem, i, match) {
        return i < match[3] - 0;
      },

      gt: function (elem, i, match) {
        return i > match[3] - 0;
      },

      nth: function (elem, i, match) {
        return match[3] - 0 === i;
      },

      eq: function (elem, i, match) {
        return match[3] - 0 === i;
      }
    },
    filter: {
      PSEUDO: function (elem, match, i, array) {
        var name = match[1],
          filter = Expr.filters[name];

        if (filter) {
          return filter(elem, i, match, array);

        } else if (name === "contains") {
          return (elem.textContent || elem.innerText || getText([elem]) || "").indexOf(match[3]) >= 0;

        } else if (name === "not") {
          var not = match[3];

          for (var j = 0, l = not.length; j < l; j++) {
            if (not[j] === elem) {
              return false;
            }
          }

          return true;

        } else {
          Sizzle.error(name);
        }
      },

      CHILD: function (elem, match) {
        var first, last,
          doneName, parent, cache,
          count, diff,
          type = match[1],
          node = elem;

        switch (type) {
          case "only":
          case "first":
            while ((node = node.previousSibling)) {
              if (node.nodeType === 1) {
                return false;
              }
            }

            if (type === "first") {
              return true;
            }

            node = elem;

          case "last":
            while ((node = node.nextSibling)) {
              if (node.nodeType === 1) {
                return false;
              }
            }

            return true;

          case "nth":
            first = match[2];
            last = match[3];

            if (first === 1 && last === 0) {
              return true;
            }

            doneName = match[0];
            parent = elem.parentNode;

            if (parent && (parent[expando] !== doneName || !elem.nodeIndex)) {
              count = 0;

              for (node = parent.firstChild; node; node = node.nextSibling) {
                if (node.nodeType === 1) {
                  node.nodeIndex = ++count;
                }
              }

              parent[expando] = doneName;
            }

            diff = elem.nodeIndex - last;

            if (first === 0) {
              return diff === 0;

            } else {
              return (diff % first === 0 && diff / first >= 0);
            }
        }
      },

      ID: function (elem, match) {
        return elem.nodeType === 1 && elem.getAttribute("id") === match;
      },

      TAG: function (elem, match) {
        return (match === "*" && elem.nodeType === 1) || !!elem.nodeName && elem.nodeName.toLowerCase() === match;
      },

      CLASS: function (elem, match) {
        return (" " + (elem.className || elem.getAttribute("class")) + " ")
          .indexOf(match) > -1;
      },

      ATTR: function (elem, match) {
        var name = match[1],
          result = Sizzle.attr ?
            Sizzle.attr(elem, name) :
            Expr.attrHandle[name] ?
              Expr.attrHandle[name](elem) :
              elem[name] != null ?
                elem[name] :
                elem.getAttribute(name),
          value = result + "",
          type = match[2],
          check = match[4];

        return result == null ?
          type === "!=" :
          !type && Sizzle.attr ?
            result != null :
            type === "=" ?
              value === check :
              type === "*=" ?
                value.indexOf(check) >= 0 :
                type === "~=" ?
                  (" " + value + " ").indexOf(check) >= 0 :
                  !check ?
                    value && result !== false :
                    type === "!=" ?
                      value !== check :
                      type === "^=" ?
                        value.indexOf(check) === 0 :
                        type === "$=" ?
                          value.substr(value.length - check.length) === check :
                          type === "|=" ?
                            value === check || value.substr(0, check.length + 1) === check + "-" :
                            false;
      },

      POS: function (elem, match, i, array) {
        var name = match[2],
          filter = Expr.setFilters[name];

        if (filter) {
          return filter(elem, i, match, array);
        }
      }
    }
  };

  var origPOS = Expr.match.POS,
    fescape = function (all, num) {
      return "\\" + (num - 0 + 1);
    };

  for (var type in Expr.match) {
    Expr.match[type] = new RegExp(Expr.match[type].source + (/(?![^\[]*\])(?![^\(]*\))/.source));
    Expr.leftMatch[type] = new RegExp(/(^(?:.|\r|\n)*?)/.source + Expr.match[type].source.replace(/\\(\d+)/g, fescape));
  }

  var makeArray = function (array, results) {
    array = Array.prototype.slice.call(array, 0);

    if (results) {
      results.push.apply(results, array);
      return results;
    }

    return array;
  };

  // Perform a simple check to determine if the browser is capable of
  // converting a NodeList to an array using builtin methods.
  // Also verifies that the returned array holds DOM nodes
  // (which is not the case in the Blackberry browser)
  try {
    Array.prototype.slice.call(document.documentElement.childNodes, 0)[0].nodeType;

    // Provide a fallback method if it does not work
  } catch (e) {
    makeArray = function (array, results) {
      var i = 0,
        ret = results || [];

      if (toString.call(array) === "[object Array]") {
        Array.prototype.push.apply(ret, array);

      } else {
        if (typeof array.length === "number") {
          for (var l = array.length; i < l; i++) {
            ret.push(array[i]);
          }

        } else {
          for (; array[i]; i++) {
            ret.push(array[i]);
          }
        }
      }

      return ret;
    };
  }

  var sortOrder, siblingCheck;

  if (document.documentElement.compareDocumentPosition) {
    sortOrder = function (a, b) {
      if (a === b) {
        hasDuplicate = true;
        return 0;
      }

      if (!a.compareDocumentPosition || !b.compareDocumentPosition) {
        return a.compareDocumentPosition ? -1 : 1;
      }

      return a.compareDocumentPosition(b) & 4 ? -1 : 1;
    };

  } else {
    sortOrder = function (a, b) {
      // The nodes are identical, we can exit early
      if (a === b) {
        hasDuplicate = true;
        return 0;

        // Fallback to using sourceIndex (in IE) if it's available on both nodes
      } else if (a.sourceIndex && b.sourceIndex) {
        return a.sourceIndex - b.sourceIndex;
      }

      var al, bl,
        ap = [],
        bp = [],
        aup = a.parentNode,
        bup = b.parentNode,
        cur = aup;

      // If the nodes are siblings (or identical) we can do a quick check
      if (aup === bup) {
        return siblingCheck(a, b);

        // If no parents were found then the nodes are disconnected
      } else if (!aup) {
        return -1;

      } else if (!bup) {
        return 1;
      }

      // Otherwise they're somewhere else in the tree so we need
      // to build up a full list of the parentNodes for comparison
      while (cur) {
        ap.unshift(cur);
        cur = cur.parentNode;
      }

      cur = bup;

      while (cur) {
        bp.unshift(cur);
        cur = cur.parentNode;
      }

      al = ap.length;
      bl = bp.length;

      // Start walking down the tree looking for a discrepancy
      for (var i = 0; i < al && i < bl; i++) {
        if (ap[i] !== bp[i]) {
          return siblingCheck(ap[i], bp[i]);
        }
      }

      // We ended someplace up the tree so do a sibling check
      return i === al ?
        siblingCheck(a, bp[i], -1) :
        siblingCheck(ap[i], b, 1);
    };

    siblingCheck = function (a, b, ret) {
      if (a === b) {
        return ret;
      }

      var cur = a.nextSibling;

      while (cur) {
        if (cur === b) {
          return -1;
        }

        cur = cur.nextSibling;
      }

      return 1;
    };
  }

  // Check to see if the browser returns elements by name when
  // querying by getElementById (and provide a workaround)
  (function () {
    // We're going to inject a fake input element with a specified name
    var form = document.createElement("div"),
      id = "script" + (new Date()).getTime(),
      root = document.documentElement;

    form.innerHTML = "<a name='" + id + "'/>";

    // Inject it into the root element, check its status, and remove it quickly
    root.insertBefore(form, root.firstChild);

    // The workaround has to do additional checks after a getElementById
    // Which slows things down for other browsers (hence the branching)
    if (document.getElementById(id)) {
      Expr.find.ID = function (match, context, isXML) {
        if (typeof context.getElementById !== "undefined" && !isXML) {
          var m = context.getElementById(match[1]);

          return m ?
            m.id === match[1] || typeof m.getAttributeNode !== "undefined" && m.getAttributeNode("id").nodeValue === match[1] ?
              [m] :
              undefined :
            [];
        }
      };

      Expr.filter.ID = function (elem, match) {
        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");

        return elem.nodeType === 1 && node && node.nodeValue === match;
      };
    }

    root.removeChild(form);

    // release memory in IE
    root = form = null;
  })();

  (function () {
    // Check to see if the browser returns only elements
    // when doing getElementsByTagName("*")

    // Create a fake element
    var div = document.createElement("div");
    div.appendChild(document.createComment(""));

    // Make sure no comments are found
    if (div.getElementsByTagName("*").length > 0) {
      Expr.find.TAG = function (match, context) {
        var results = context.getElementsByTagName(match[1]);

        // Filter out possible comments
        if (match[1] === "*") {
          var tmp = [];

          for (var i = 0; results[i]; i++) {
            if (results[i].nodeType === 1) {
              tmp.push(results[i]);
            }
          }

          results = tmp;
        }

        return results;
      };
    }

    // Check to see if an attribute returns normalized href attributes
    div.innerHTML = "<a href='#'></a>";

    if (div.firstChild && typeof div.firstChild.getAttribute !== "undefined" &&
      div.firstChild.getAttribute("href") !== "#") {

      Expr.attrHandle.href = function (elem) {
        return elem.getAttribute("href", 2);
      };
    }

    // release memory in IE
    div = null;
  })();

  if (document.querySelectorAll) {
    (function () {
      var oldSizzle = Sizzle,
        div = document.createElement("div"),
        id = "__sizzle__";

      div.innerHTML = "<p class='TEST'></p>";

      // Safari can't handle uppercase or unicode characters when
      // in quirks mode.
      if (div.querySelectorAll && div.querySelectorAll(".TEST").length === 0) {
        return;
      }

      Sizzle = function (query, context, extra, seed) {
        context = context || document;

        // Only use querySelectorAll on non-XML documents
        // (ID selectors don't work in non-HTML documents)
        if (!seed && !Sizzle.isXML(context)) {
          // See if we find a selector to speed up
          var match = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(query);

          if (match && (context.nodeType === 1 || context.nodeType === 9)) {
            // Speed-up: Sizzle("TAG")
            if (match[1]) {
              return makeArray(context.getElementsByTagName(query), extra);

              // Speed-up: Sizzle(".CLASS")
            } else if (match[2] && Expr.find.CLASS && context.getElementsByClassName) {
              return makeArray(context.getElementsByClassName(match[2]), extra);
            }
          }

          if (context.nodeType === 9) {
            // Speed-up: Sizzle("body")
            // The body element only exists once, optimize finding it
            if (query === "body" && context.body) {
              return makeArray([context.body], extra);

              // Speed-up: Sizzle("#ID")
            } else if (match && match[3]) {
              var elem = context.getElementById(match[3]);

              // Check parentNode to catch when Blackberry 4.6 returns
              // nodes that are no longer in the document #6963
              if (elem && elem.parentNode) {
                // Handle the case where IE and Opera return items
                // by name instead of ID
                if (elem.id === match[3]) {
                  return makeArray([elem], extra);
                }

              } else {
                return makeArray([], extra);
              }
            }

            try {
              return makeArray(context.querySelectorAll(query), extra);
            } catch (qsaError) { }

            // qSA works strangely on Element-rooted queries
            // We can work around this by specifying an extra ID on the root
            // and working up from there (Thanks to Andrew Dupont for the technique)
            // IE 8 doesn't work on object elements
          } else if (context.nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
            var oldContext = context,
              old = context.getAttribute("id"),
              nid = old || id,
              hasParent = context.parentNode,
              relativeHierarchySelector = /^\s*[+~]/.test(query);

            if (!old) {
              context.setAttribute("id", nid);
            } else {
              nid = nid.replace(/'/g, "\\$&");
            }
            if (relativeHierarchySelector && hasParent) {
              context = context.parentNode;
            }

            try {
              if (!relativeHierarchySelector || hasParent) {
                return makeArray(context.querySelectorAll("[id='" + nid + "'] " + query), extra);
              }

            } catch (pseudoError) {
            } finally {
              if (!old) {
                oldContext.removeAttribute("id");
              }
            }
          }
        }

        return oldSizzle(query, context, extra, seed);
      };

      for (var prop in oldSizzle) {
        Sizzle[prop] = oldSizzle[prop];
      }

      // release memory in IE
      div = null;
    })();
  }

  (function () {
    var html = document.documentElement,
      matches = html.matchesSelector || html.mozMatchesSelector || html.webkitMatchesSelector || html.msMatchesSelector;

    if (matches) {
      // Check to see if it's possible to do matchesSelector
      // on a disconnected node (IE 9 fails this)
      var disconnectedMatch = !matches.call(document.createElement("div"), "div"),
        pseudoWorks = false;

      try {
        // This should fail with an exception
        // Gecko does not error, returns false instead
        matches.call(document.documentElement, "[test!='']:sizzle");

      } catch (pseudoError) {
        pseudoWorks = true;
      }

      Sizzle.matchesSelector = function (node, expr) {
        // Make sure that attribute selectors are quoted
        expr = expr.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']");

        if (!Sizzle.isXML(node)) {
          try {
            if (pseudoWorks || !Expr.match.PSEUDO.test(expr) && !/!=/.test(expr)) {
              var ret = matches.call(node, expr);

              // IE 9's matchesSelector returns false on disconnected nodes
              if (ret || !disconnectedMatch ||
                // As well, disconnected nodes are said to be in a document
                // fragment in IE 9, so check for that
                node.document && node.document.nodeType !== 11) {
                return ret;
              }
            }
          } catch (e) { }
        }

        return Sizzle(expr, null, null, [node]).length > 0;
      };
    }
  })();

  (function () {
    var div = document.createElement("div");

    div.innerHTML = "<div class='test e'></div><div class='test'></div>";

    // Opera can't find a second classname (in 9.6)
    // Also, make sure that getElementsByClassName actually exists
    if (!div.getElementsByClassName || div.getElementsByClassName("e").length === 0) {
      return;
    }

    // Safari caches class attributes, doesn't catch changes (in 3.2)
    div.lastChild.className = "e";

    if (div.getElementsByClassName("e").length === 1) {
      return;
    }

    Expr.order.splice(1, 0, "CLASS");
    Expr.find.CLASS = function (match, context, isXML) {
      if (typeof context.getElementsByClassName !== "undefined" && !isXML) {
        return context.getElementsByClassName(match[1]);
      }
    };

    // release memory in IE
    div = null;
  })();

  function dirNodeCheck (dir, cur, doneName, checkSet, nodeCheck, isXML) {
    for (var i = 0, l = checkSet.length; i < l; i++) {
      var elem = checkSet[i];

      if (elem) {
        var match = false;

        elem = elem[dir];

        while (elem) {
          if (elem[expando] === doneName) {
            match = checkSet[elem.sizset];
            break;
          }

          if (elem.nodeType === 1 && !isXML) {
            elem[expando] = doneName;
            elem.sizset = i;
          }

          if (elem.nodeName.toLowerCase() === cur) {
            match = elem;
            break;
          }

          elem = elem[dir];
        }

        checkSet[i] = match;
      }
    }
  }

  function dirCheck (dir, cur, doneName, checkSet, nodeCheck, isXML) {
    for (var i = 0, l = checkSet.length; i < l; i++) {
      var elem = checkSet[i];

      if (elem) {
        var match = false;

        elem = elem[dir];

        while (elem) {
          if (elem[expando] === doneName) {
            match = checkSet[elem.sizset];
            break;
          }

          if (elem.nodeType === 1) {
            if (!isXML) {
              elem[expando] = doneName;
              elem.sizset = i;
            }

            if (typeof cur !== "string") {
              if (elem === cur) {
                match = true;
                break;
              }

            } else if (Sizzle.filter(cur, [elem]).length > 0) {
              match = elem;
              break;
            }
          }

          elem = elem[dir];
        }

        checkSet[i] = match;
      }
    }
  }

  if (document.documentElement.contains) {
    Sizzle.contains = function (a, b) {
      return a !== b && (a.contains ? a.contains(b) : true);
    };

  } else if (document.documentElement.compareDocumentPosition) {
    Sizzle.contains = function (a, b) {
      return !!(a.compareDocumentPosition(b) & 16);
    };

  } else {
    Sizzle.contains = function () {
      return false;
    };
  }

  Sizzle.isXML = function (elem) {
    // documentElement is verified for cases where it doesn't yet exist
    // (such as loading iframes in IE - #4833)
    var documentElement = (elem ? elem.ownerDocument || elem : 0).documentElement;

    return documentElement ? documentElement.nodeName !== "HTML" : false;
  };

  var posProcess = function (selector, context, seed) {
    var match,
      tmpSet = [],
      later = "",
      root = context.nodeType ? [context] : context;

    // Position selectors must be done after the filter
    // And so must :not(positional) so we move all PSEUDOs to the end
    while ((match = Expr.match.PSEUDO.exec(selector))) {
      later += match[0];
      selector = selector.replace(Expr.match.PSEUDO, "");
    }

    selector = Expr.relative[selector] ? selector + "*" : selector;

    for (var i = 0, l = root.length; i < l; i++) {
      Sizzle(selector, root[i], tmpSet, seed);
    }

    return Sizzle.filter(later, tmpSet);
  };

  // EXPOSE

  baidu.query = baidu.dom.query = Sizzle;

})();

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */




/**
 * 使函数在页面dom节点加载完毕时调用
 * @author allstar
 * @name baidu.dom.ready
 * @function
 * @grammar baidu.dom.ready(callback)
 * @param {Function} callback 页面加载完毕时调用的函数.
 * @remark
 * 如果有条件将js放在页面最底部, 也能达到同样效果，不必使用该方法。
 * @meta standard
 */
(function () {
  var logParam = {};
  var readyStart = new Date().valueOf();
  var ready = baidu.dom.ready = function () {
    window.vplayDomReadyStartTime = new Date().getTime();
    var readyBound = false,
      readyList = [],
      DOMContentLoaded;

    if (document.addEventListener) {
      DOMContentLoaded = function () {
        document.removeEventListener('DOMContentLoaded', DOMContentLoaded, false);
        ready();
      };

    } else if (document.attachEvent) {
      DOMContentLoaded = function () {
        if (document.readyState === 'complete') {
          document.detachEvent('onreadystatechange', DOMContentLoaded);
          ready();
        }
      };
    }

    function ready () {
      if (!ready.isReady) {
        logParam.readytime = new Date().valueOf() - readyStart;
        ready.isReady = true;
        //fix by wangxk
        baidu.dom.ready.isReady = true;
        var t0 = new Date().valueOf();
        for (var i = 0, j = readyList.length; i < j; i++) {
          //try{
          readyList[i]();
          //}catch(e){
          //    console.error("**T.ready err:"+e+"");
          //}
        }
        if (window.qa) {
          logParam.rendertime = new Date().valueOf() - t0;
          window.qa.logInit(logParam);
        }
      }
    }

    function doScrollCheck () {
      try {
        document.documentElement.doScroll("left");
      } catch (e) {
        setTimeout(doScrollCheck, 1);
        return;
      }
      ready();
    }

    function bindReady () {
      if (readyBound) {
        return;
      }
      readyBound = true;

      if (document.addEventListener) {

        document.addEventListener('DOMContentLoaded', DOMContentLoaded, false);
        window.addEventListener('load', ready, false);

      } else if (document.attachEvent) {

        document.attachEvent('onreadystatechange', DOMContentLoaded);
        window.attachEvent('onload', ready);

        var toplevel = false;

        try {
          toplevel = window.frameElement == null;
        } catch (e) { }

        if (document.documentElement.doScroll && toplevel) {
          doScrollCheck();
        }
      }
    }
    bindReady();

    return function (callback) {
      try {
        ready.isReady ? callback() : readyList.push(callback);
      } catch (e) { }
    };
  }();

  ready.isReady = false;
})();
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/remove.js
 * author: allstar,berg
 * version: 1.1.0
 * date: 2009/11/17
 */

baidu.ready = baidu.dom.ready;


/**
 * 从DOM树上移除目标元素
 * @name baidu.dom.remove
 * @function
 * @grammar baidu.dom.remove(element)
 * @param {HTMLElement|string} element 需要移除的元素或元素的id
 * @remark
 * <b>注意：</b>对于移除的dom元素，IE下会释放该元素的空间，继续使用该元素的引用进行操作将会引发不可预料的问题。
 * @meta standard
 */
baidu.dom.remove = function (element) {
  element = baidu.dom._g(element);
  var tmpEl = element.parentNode;
  //去掉了对ie下的特殊处理：创建一个div，appendChild，然后div.innerHTML = ""
  tmpEl && tmpEl.removeChild(element);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/removeClass.js
 * author: allstar, erik
 * version: 1.1.0
 * date: 2009/12/02
 */




/**
 * 移除目标元素的className
 * @name baidu.dom.removeClass
 * @function
 * @grammar baidu.dom.removeClass(element, className)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} className 要移除的className，允许同时移除多个class，中间使用空白符分隔
 * @remark
 * 使用者应保证提供的className合法性，不应包含不合法字符，className合法字符参考：http://www.w3.org/TR/CSS2/syndata.html。
 * @shortcut removeClass
 * @meta standard
 * @see baidu.dom.addClass
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.removeClass = function (element, className) {
  element = baidu.dom.g(element);
  if (!element) {
    console.error("*** Error:removeClass找不到元素", element, ",caller=", arguments.caller);
    return;
  }

  var oldClasses = element.className.split(/\s+/),
    newClasses = className.split(/\s+/),
    lenOld,
    lenDel = newClasses.length,
    j,
    i = 0;
  //考虑到同时删除多个className的应用场景概率较低,故放弃进一步性能优化
  // by rocy @1.3.4
  for (; i < lenDel; ++i) {
    for (j = 0, lenOld = oldClasses.length; j < lenOld; ++j) {
      if (oldClasses[j] == newClasses[i]) {
        oldClasses.splice(j, 1);
        break;
      }
    }
  }
  element.className = oldClasses.join(' ');
  return element;
};

// 声明快捷方法
baidu.removeClass = baidu.dom.removeClass;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/setStyle.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/18
 */






/**
 * 设置目标元素的style样式值
 * @name baidu.dom.setStyle
 * @function
 * @grammar baidu.dom.setStyle(element, key, value)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {string} key 要设置的样式名
 * @param {string} value 要设置的样式值
 * @remark
 *
            为了精简代码，本模块默认不对任何浏览器返回值进行归一化处理（如使用getStyle时，不同浏览器下可能返回rgb颜色或hex颜色），也不会修复浏览器的bug和差异性（如设置IE的float属性叫styleFloat，firefox则是cssFloat）。<br />
baidu.dom._styleFixer和baidu.dom._styleFilter可以为本模块提供支持。<br />
其中_styleFilter能对颜色和px进行归一化处理，_styleFixer能对display，float，opacity，textOverflow的浏览器兼容性bug进行处理。

 * @shortcut setStyle
 * @meta standard
 * @see baidu.dom.getStyle,baidu.dom.setStyles
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.setStyle = function (element, key, value) {
  var dom = baidu.dom, fixer;

  // 放弃了对firefox 0.9的opacity的支持
  element = dom.g(element);
  key = baidu.string.toCamelCase(key);

  if (fixer = dom._styleFilter) {
    value = fixer.filter(key, value, 'set');
  }

  fixer = dom._styleFixer[key];
  (fixer && fixer.set) ? fixer.set(element, value) : (element.style[fixer || key] = value);

  return element;
};

// 声明快捷方法
baidu.setStyle = baidu.dom.setStyle;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/setStyles.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/18
 */




/**
 * 批量设置目标元素的style样式值
 * @name baidu.dom.setStyles
 * @function
 * @grammar baidu.dom.setStyles(element, styles)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @param {Object} styles 要设置的样式集合
 * @shortcut setStyles
 * @meta standard
 * @see baidu.dom.setStyle,baidu.dom.getStyle
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.setStyles = function (element, styles) {
  element = baidu.dom.g(element);

  for (var key in styles) {
    baidu.dom.setStyle(element, key, styles[key]);
  }

  return element;
};

// 声明快捷方法
baidu.setStyles = baidu.dom.setStyles;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 删除元素的某个样式
 * @name baidu.dom.removeStyle
 * @function
 * @grammar baidu.dom.removeStyle(element, styleName)
 * @param {HTMLElement|String} element 需要删除样式的元素或者元素id
 * @param {string} styleName 需要删除的样式名字
 * @version 1.3
 * @see baidu.dom.setStyle
 *
 * @returns {HTMLElement} 目标元素
 */

// todo: 1. 只支持现代浏览器，有一些老浏览器可能不支持; 2. 有部分属性无法被正常移除
baidu.removeStyle = baidu.dom.removeStyle = function () {
  var ele = document.createElement("DIV"),
    fn,
    _g = baidu.dom._g;

  if (ele.style.removeProperty) {// W3C, (gecko, opera, webkit)
    fn = function (el, st) {
      el = _g(el);
      el.style.removeProperty(st);
      return el;
    };
  } else if (ele.style.removeAttribute) { // IE
    fn = function (el, st) {
      el = _g(el);
      el.style.removeAttribute(baidu.string.toCamelCase(st));
      return el;
    };
  }
  ele = null;
  return fn;
}();



/**
 * 显示目标元素，即将目标元素的display属性还原成默认值。默认值可能在stylesheet中定义，或者是继承了浏览器的默认样式值
 * @author allstar, berg
 * @name baidu.dom.show
 * @function
 * @grammar baidu.dom.show(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @remark
 * 注意1：如果在CSS中定义此元素的样式为display:none
 * 在调用本函数以后，会将display属性仍然还原成none，元素仍然无法显示。
 * 注意2：如果这个元素的display属性被设置成inline
 * （由element.style.display或者HTML中的style属性设置）
 * 调用本方法将清除此inline属性，导致元素的display属性变成继承值
 * 因此，针对上面两种情况，建议使用dom.setStyle("display", "something")
 * 来明确指定要设置的display属性值。
 *
 * @shortcut show
 * @meta standard
 * @see baidu.dom.hide,baidu.dom.toggle
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.show = function (element) {
  element = baidu.dom.g(element);
  if (element) element.style.display = "block";
  return element;
};

// 声明快捷方法
baidu.show = baidu.dom.show;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/dom/toggle.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 改变目标元素的显示/隐藏状态
 * @name baidu.dom.toggle
 * @function
 * @grammar baidu.dom.toggle(element)
 * @param {HTMLElement|string} element 目标元素或目标元素的id
 * @meta standard
 * @see baidu.dom.show,baidu.dom.hide
 *
 * @returns {HTMLElement} 目标元素
 */
baidu.dom.toggle = function (element) {
  element = baidu.dom.g(element);
  element.style.display = element.style.display == "none" ? "" : "none";

  return element;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */



/**
 * @namespace baidu.event 屏蔽浏览器差异性的事件封装。
 * @property target	事件的触发元素
 * @property pageX	鼠标事件的鼠标x坐标
 * @property pageY	鼠标事件的鼠标y坐标
 * @property keyCode	键盘事件的键值
 */
baidu.event = baidu.event || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/EventArg.js
 * author: erik
 * version: 1.1.0
 * date: 2010/01/11
 */


/**
 * 获取鼠标事件的鼠标x坐标
 * @name baidu.event.getPageX
 * @function
 * @grammar baidu.event.getPageX(event)
 * @param {Event} event 事件对象
 * @see baidu.event.getPageY
 *
 * @returns {number} 鼠标事件的鼠标x坐标
 */
baidu.event.getPageX = function (event) {
  var result = event.pageX,
    doc = document;
  if (!result && result !== 0) {
    result = (event.clientX || 0) + (doc.documentElement.scrollLeft || doc.body.scrollLeft);
  }
  return result;
};


/**
 * 获取鼠标事件的鼠标y坐标
 * @name baidu.event.getPageY
 * @function
 * @grammar baidu.event.getPageY(event)
 * @param {Event} event 事件对象
 * @see baidu.event.getPageX
 *
 * @returns {number} 鼠标事件的鼠标y坐标
 */
baidu.event.getPageY = function (event) {
  var result = event.pageY,
    doc = document;
  if (!result && result !== 0) {
    result = (event.clientY || 0) + (doc.documentElement.scrollTop || doc.body.scrollTop);
  }
  return result;
};

/**
 * 事件对象构造器，屏蔽浏览器差异的事件类
 * @name baidu.event.EventArg
 * @class
 * @grammar baidu.event.EventArg(event[, win])
 * @param {Event}   event   事件对象
 * @param {Window}  [win]	窗口对象，默认为window
 * @meta standard
 * @remark 1.1.0开始支持
 * @see baidu.event.get
 */
baidu.event.EventArg = function (event, win) {
  win = win || window;
  event = event || win.event;
  var doc = win.document;

  this.target = /** @type {Node} */ (event.target) || event.srcElement;
  this.keyCode = event.which || event.keyCode;
  for (var k in event) {
    var item = event[k];
    // 避免拷贝preventDefault等事件对象方法
    if ('function' != typeof item) {
      this[k] = item;
    }
  }

  if (!this.pageX && this.pageX !== 0) {
    this.pageX = (event.clientX || 0) + (doc.documentElement.scrollLeft || doc.body.scrollLeft);
    this.pageY = (event.clientY || 0) + (doc.documentElement.scrollTop || doc.body.scrollTop);
  }
  this._event = event;
};

/**
 * 阻止事件的默认行为
 * @name preventDefault
 * @grammar eventArgObj.preventDefault()
 * @returns {baidu.event.EventArg} EventArg对象
 */
baidu.event.EventArg.prototype.preventDefault = function () {
  if (this._event.preventDefault) {
    this._event.preventDefault();
  } else {
    this._event.returnValue = false;
  }
  return this;
};

/**
 * 停止事件的传播
 * @name stopPropagation
 * @grammar eventArgObj.stopPropagation()
 * @returns {baidu.event.EventArg} EventArg对象
 */
baidu.event.EventArg.prototype.stopPropagation = function () {
  if (this._event.stopPropagation) {
    this._event.stopPropagation();
  } else {
    this._event.cancelBubble = true;
  }
  return this;
};

/**
 * 停止事件
 * @name stop
 * @grammar eventArgObj.stop()
 * @returns {baidu.event.EventArg} EventArg对象
 */
baidu.event.EventArg.prototype.stop = function () {
  return this.stopPropagation().preventDefault();
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/_listeners.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 事件监听器的存储表
 * @private
 * @meta standard
 */
baidu.event._listeners = baidu.event._listeners || [];
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/get.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 获取扩展的EventArg对象
 * @name baidu.event.get
 * @function
 * @grammar baidu.event.get(event[, win])
 * @param {Event} event 事件对象
 * @param {window} [win] 触发事件元素所在的window
 * @meta standard
 * @see baidu.event.EventArg
 *
 * @returns {EventArg} 扩展的事件对象
 */
baidu.event.get = function (event, win) {
  return new baidu.event.EventArg(event, win);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/getTarget.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 获取事件的触发元素
 * @name baidu.event.getTarget
 * @function
 * @grammar baidu.event.getTarget(event)
 * @param {Event} event 事件对象
 * @meta standard
 * @returns {HTMLElement} 事件的触发元素
 */

baidu.event.getTarget = function (event) {
  return event.target || event.srcElement;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/on.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/16
 */




/**
 * 为目标元素添加事件监听器
 * @name baidu.event.on
 * @function
 * @grammar baidu.event.on(element, type, listener)
 * @param {HTMLElement|string|window} element 目标元素或目标元素id
 * @param {string} type 事件类型
 * @param {Function} listener 需要添加的监听器
 * @remark
 *
1. 不支持跨浏览器的鼠标滚轮事件监听器添加<br>
2. 改方法不为监听器灌入事件对象，以防止跨iframe事件挂载的事件对象获取失败

 * @shortcut on
 * @meta standard
 * @see baidu.event.un
 *
 * @returns {HTMLElement|window} 目标元素
 */
baidu.event.on = function (element, type, listener) {
  type = type.replace(/^on/i, '');
  element = baidu.dom._g(element);
  if (!element) {
    console.error("*** Error:找不到元素", element, ",caller=", arguments.caller);
    return;
  }
  var realListener = function (ev) {
    // 1. 这里不支持EventArgument,  原因是跨frame的事件挂载
    // 2. element是为了修正this
    listener.call(element, ev);
  },
    lis = baidu.event._listeners,
    filter = baidu.event._eventFilter,
    afterFilter,
    realType = type;
  type = type.toLowerCase();
  // filter过滤
  if (filter && filter[type]) {
    afterFilter = filter[type](element, type, realListener);
    realType = afterFilter.type;
    realListener = afterFilter.listener;
  }

  // 事件监听器挂载
  if (element.addEventListener) {
    element.addEventListener(realType, realListener, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + realType, realListener);
  }

  // 将监听器存储到数组中
  lis[lis.length] = [element, type, listener, realListener, realType];
  return element;
};

// 声明快捷方法
baidu.on = baidu.event.on;

// 添加hover方法
baidu.hover = function (element, over, out) {
  var hlist = baidu.isString(element) ? baidu.query(element) : [baidu.dom.g(element)];

  if (baidu.isString(over)) {
    var newClassName = over;
    over = function (e) {
      baidu.event.stopPropagation(e);
      baidu.addClass(this, newClassName);
    };
    out = function (e) {
      baidu.event.stopPropagation(e);
      baidu.removeClass(this, newClassName);
    };
  }

  baidu.object.each(hlist, function (a) {
    baidu.event.on(a, "mouseover", over);
    baidu.event.on(a, "mouseout", out);
  });

  return baidu;
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/preventDefault.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/23
 */



/**
 * 阻止事件的默认行为
 * @name baidu.event.preventDefault
 * @function
 * @grammar baidu.event.preventDefault(event)
 * @param {Event} event 事件对象
 * @meta standard
 * @see baidu.event.stop,baidu.event.stopPropagation
 */
baidu.event.preventDefault = function (event) {
  if (event.preventDefault) {
    event.preventDefault();
  } else {
    event.returnValue = false;
  }
};
/**
 * 阻止事件传播
 * @name baidu.event.stopPropagation
 * @function
 * @grammar baidu.event.stopPropagation(event)
 * @param {Event} event 事件对象
 * @see baidu.event.stop,baidu.event.preventDefault
 */
baidu.event.stopPropagation = function (event) {
  if (event.stopPropagation) {
    event.stopPropagation();
  } else {
    event.cancelBubble = true;
  }
};
/**
 * 停止事件
 * @name baidu.event.stop
 * @function
 * @grammar baidu.event.stop(event)
 * @param {Event} event 事件对象
 * @see baidu.event.stopPropagation,baidu.event.preventDefault
 */
baidu.event.stop = function (event) {
  var e = baidu.event;
  e.stopPropagation(event);
  e.preventDefault(event);
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/event/un.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/16
 */




/**
 * 为目标元素移除事件监听器
 * @name baidu.event.un
 * @function
 * @grammar baidu.event.un(element, type, listener)
 * @param {HTMLElement|string|window} element 目标元素或目标元素id
 * @param {string} type 事件类型
 * @param {Function} listener 需要移除的监听器
 * @shortcut un
 * @meta standard
 * @see baidu.event.on
 *
 * @returns {HTMLElement|window} 目标元素
 */
baidu.event.un = function (element, type, listener) {
  element = baidu.dom._g(element);
  type = type.replace(/^on/i, '').toLowerCase();

  var lis = baidu.event._listeners,
    len = lis.length,
    isRemoveAll = !listener,
    item,
    realType, realListener;

  //如果将listener的结构改成json
  //可以节省掉这个循环，优化性能
  //但是由于un的使用频率并不高，同时在listener不多的时候
  //遍历数组的性能消耗不会对代码产生影响
  //暂不考虑此优化
  while (len--) {
    item = lis[len];
    // listener存在时，移除element的所有以listener监听的type类型事件
    // listener不存在时，移除element的所有type类型事件
    if (item[1] === type && item[0] === element && (isRemoveAll || item[2] === listener)) {
      realType = item[4];
      realListener = item[3];
      if (element.removeEventListener) {
        element.removeEventListener(realType, realListener, false);
      } else if (element.detachEvent) {
        element.detachEvent('on' + realType, realListener);
      }
      lis.splice(len, 1);
    }
  }

  return element;
};

// 声明快捷方法
baidu.un = baidu.event.un;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/json.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/02
 */


/**
 * @namespace baidu.json 操作json对象的方法。
 */
baidu.json = baidu.json || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/json/parse.js
 * author: erik, berg
 * version: 1.2
 * date: 2009/11/23
 */



/**
 * 将字符串解析成json对象。注：不会自动祛除空格
 * @name baidu.json.parse
 * @function
 * @grammar baidu.json.parse(data)
 * @param {string} source 需要解析的字符串
 * @remark
 * 该方法的实现与ecma-262第五版中规定的JSON.parse不同，暂时只支持传入一个参数。后续会进行功能丰富。
 * @meta standard
 * @see baidu.json.stringify,baidu.json.decode
 *
 * @returns {JSON} 解析结果json对象
 */
baidu.json.parse = function (data) {
  //2010/12/09：更新至不使用原生parse，不检测用户输入是否正确
  data = data.toString();
  if (!data.length) return null;
  try {
    return (new Function("return (" + data + ")"))();
  } catch (e) {
    return null;
  }
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/json/stringify.js
 * author: erik
 * version: 1.1.0
 * date: 2010/01/11
 */



/**
 * 将json对象序列化
 * @name baidu.json.stringify
 * @function
 * @grammar baidu.json.stringify(value)
 * @param {JSON} value 需要序列化的json对象
 * @remark
 * 该方法的实现与ecma-262第五版中规定的JSON.stringify不同，暂时只支持传入一个参数。后续会进行功能丰富。
 * @meta standard
 * @see baidu.json.parse,baidu.json.encode
 *
 * @returns {string} 序列化后的字符串
 */
baidu.json.encode = baidu.json.stringify = (function () {
  /**
   * 字符串处理时需要转义的字符表
   * @private
   */
  var escapeMap = {
    "\b": '\\b',
    "\t": '\\t',
    "\n": '\\n',
    "\f": '\\f',
    "\r": '\\r',
    '"': '\\"',
    "\\": '\\\\'
  };

  /**
   * 字符串序列化
   * @private
   */
  function encodeString (source) {
    if (/["\\\x00-\x1f]/.test(source)) {
      source = source.replace(
        /["\\\x00-\x1f]/g,
        function (match) {
          var c = escapeMap[match];
          if (c) {
            return c;
          }
          c = match.charCodeAt();
          return "\\u00" + Math.floor(c / 16).toString(16) + (c % 16).toString(16);
        });
    }
    return '"' + source + '"';
  }

  /**
   * 数组序列化
   * @private
   */
  function encodeArray (source) {
    var result = ["["],
      l = source.length,
      preComma, i, item;

    for (i = 0; i < l; i++) {
      item = source[i];

      switch (typeof item) {
        case "undefined":
        case "function":
        case "unknown":
          break;
        default:
          if (preComma) {
            result.push(',');
          }
          result.push(baidu.json.stringify(item));
          preComma = 1;
      }
    }
    result.push("]");
    return result.join("");
  }

  /**
   * 处理日期序列化时的补零
   * @private
   */
  function pad (source) {
    return source < 10 ? '0' + source : source;
  }

  /**
   * 日期序列化
   * @private
   */
  function encodeDate (source) {
    return '"' + source.getFullYear() + "-" +
      pad(source.getMonth() + 1) + "-" +
      pad(source.getDate()) + "T" +
      pad(source.getHours()) + ":" +
      pad(source.getMinutes()) + ":" +
      pad(source.getSeconds()) + '"';
  }

  return function (value) {
    switch (typeof value) {
      case 'undefined':
        return 'undefined';

      case 'number':
        return isFinite(value) ? String(value) : "null";

      case 'string':
        return encodeString(value);

      case 'boolean':
        return String(value);

      default:
        if (value === null) {
          return 'null';
        } else if (value instanceof Array) {
          return encodeArray(value);
        } else if (value instanceof Date) {
          return encodeDate(value);
        } else {
          var result = ['{'],
            encode = baidu.json.stringify,
            preComma,
            item;

          for (var key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
              item = value[key];
              switch (typeof item) {
                case 'undefined':
                case 'unknown':
                case 'function':
                  break;
                default:
                  if (preComma) {
                    result.push(',');
                  }
                  preComma = 1;
                  result.push(encode(key) + ':' + encode(item));
              }
            }
          }
          result.push('}');
          return result.join('');
        }
    }
  };
})();
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/guid.js
 * author: meizz
 * version: 1.1.0
 * date: 2010/02/04
 */

/**
 * 返回一个当前页面的唯一标识字符串。
 * @name baidu.lang.guid
 * @function
 * @grammar baidu.lang.guid()
 * @version 1.1.1
 * @meta standard
 *
 * @returns {String} 当前页面的唯一标识字符串
 */
baidu.lang.guid = function () {
  return "TANGRAM$" + baidu.$$._counter++;
};

//不直接使用window，可以提高3倍左右性能
baidu.$$._counter = baidu.$$._counter || 1;


// 20111129 meizz   去除 _counter.toString(36) 这步运算，节约计算量
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/_instances.js
 * author: meizz, erik
 * version: 1.1.0
 * date: 2009/12/1
 */




/**
 * 所有类的实例的容器
 * key为每个实例的guid
 * @meta standard
 */

window[baidu.guid]._instances = window[baidu.guid]._instances || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/isFunction.js
 * author: rocy
 * version: 1.1.2
 * date: 2010/06/12
 */



/**
 * 判断目标参数是否为function或Function实例
 * @name baidu.lang.isFunction
 * @function
 * @grammar baidu.lang.isFunction(source)
 * @param {Any} source 目标参数
 * @version 1.2
 * @see baidu.lang.isString,baidu.lang.isObject,baidu.lang.isNumber,baidu.lang.isArray,baidu.lang.isElement,baidu.lang.isBoolean,baidu.lang.isDate
 * @meta standard
 * @returns {boolean} 类型判断结果
 */
baidu.isFunction = baidu.lang.isFunction = function (source) {
  // chrome下,'function' == typeof /a/ 为true.
  return '[object Function]' == Object.prototype.toString.call(source);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/Class.js
 * author: meizz, erik
 * version: 1.1.0
 * date: 2009/12/1
 */





/**
 * Tangram继承机制提供的一个基类，用户可以通过继承baidu.lang.Class来获取它的属性及方法。
 * @class
 * @name	baidu.lang.Class
 * @grammar baidu.lang.Class(guid)
 * @param	{string}	guid	对象的唯一标识
 * @meta standard
 * @remark baidu.lang.Class和它的子类的实例均包含一个全局唯一的标识guid。guid是在构造函数中生成的，因此，继承自baidu.lang.Class的类应该直接或者间接调用它的构造函数。<br>baidu.lang.Class的构造函数中产生guid的方式可以保证guid的唯一性，及每个实例都有一个全局唯一的guid。
 * @meta standard
 * @see baidu.lang.inherits,baidu.lang.Event
 */
baidu.lang.Class = function (guid) {
  this.guid = guid || baidu.lang.guid();
  window[baidu.guid]._instances[this.guid] = this;
};
window[baidu.guid]._instances = window[baidu.guid]._instances || {};

/**
 * 释放对象所持有的资源，主要是自定义事件。
 * @name dispose
 * @grammar obj.dispose()
 * TODO: 将_listeners中绑定的事件剔除掉
 */
baidu.lang.Class.prototype.dispose = function () {
  delete window[baidu.guid]._instances[this.guid];

  for (var property in this) {
    if (!baidu.lang.isFunction(this[property])) {
      delete this[property];
    }
  }
  this.disposed = true;   // 20100716
};

/**
 * 重载了默认的toString方法，使得返回信息更加准确一些。
 * @return {string} 对象的String表示形式
 */
baidu.lang.Class.prototype.toString = function () {
  return "[object " + (this._className || "Object") + "]";
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/Event.js
 * author: meizz, erik, berg
 * version: 1.1.1
 * date: 2009/11/24
 * modify: 2010/04/19 berg
 */






/**
 * 自定义的事件对象。
 * @class
 * @name	baidu.lang.Event
 * @grammar	baidu.lang.Event(type[, target])
 * @param	{string} type	事件类型名称。为了方便区分事件和一个普通的方法，事件类型名称必须以"on"(小写)开头。
 * @param	{Object} [target]触发事件的对象
 * @meta standard
 * @remark 引入该模块，会自动为Class引入3个事件扩展方法：addEventListener、removeEventListener和dispatchEvent。
 * @meta standard
 * @see baidu.lang.Class
 */
baidu.lang.Event = function (type, target) {
  this.type = type;
  this.returnValue = true;
  this.target = target || null;
  this.currentTarget = null;
};

/**
 * 注册对象的事件监听器。引入baidu.lang.Event后，Class的子类实例才会获得该方法。
 * @grammar obj.addEventListener(type, handler[, key])
 * @param	{string}	type         自定义事件的名称
 * @param	{Function}	handler      自定义事件被触发时应该调用的回调函数
 * @param	{string}	[key]		为事件监听函数指定的名称，可在移除时使用。如果不提供，方法会默认为它生成一个全局唯一的key。
 * @remark事件类型区分大小写。如果自定义事件名称不是以小写"on"开头，该方法会给它加上"on"再进行判断，即"click"和"onclick"会被认为是同一种事件。
 */
baidu.lang.Class.prototype.add = baidu.lang.Class.prototype.addEventListener = function (type, handler, key) {
  if (!baidu.lang.isFunction(handler)) {
    return this;
  }
  !this.__listeners && (this.__listeners = {});

  var t = this.__listeners, id;
  if (typeof key == "string" && key) {
    if (/[^\w\-]/.test(key)) {
      throw ("nonstandard key:" + key);
    } else {
      handler.hashCode = key;
      id = key;
    }
  }
  type.indexOf("on") !== 0 && (type = "on" + type);
  typeof t[type] != "object" && (t[type] = {});
  id = id || baidu.lang.guid();
  handler.hashCode = id;
  t[type][id] = handler;

  return this;
};

/**
 * 移除对象的事件监听器。引入baidu.lang.Event后，Class的子类实例才会获得该方法。
 * @grammar	obj.removeEventListener(type, handler)
 * @param	{string}	type	事件类型
 * @param	{Function|string} handler  要移除的事件监听函数或者监听函数的key
 * @remark	如果第二个参数handler没有被绑定到对应的自定义事件中，什么也不做。
 */
baidu.lang.Class.prototype.remove = baidu.lang.Class.prototype.removeEventListener = function (type, handler) {
  if (typeof handler != "undefined") {
    if ((baidu.lang.isFunction(handler) && !(handler = handler.hashCode)) || (!baidu.lang.isString(handler))) {
      return this;
    }
  }

  !this.__listeners && (this.__listeners = {});

  (type.indexOf("on") !== 0) && (type = "on" + type);

  var t = this.__listeners;
  if (!t[type]) {
    return this;
  }
  if (typeof handler != "undefined") {
    t[type][handler] && delete t[type][handler];
  } else {
    for (var guid in t[type]) {
      delete t[type][guid];
    }
  }
  return this;
};

/**
 * 派发自定义事件，使得绑定到自定义事件上面的函数都会被执行。引入baidu.lang.Event后，Class的子类实例才会获得该方法。
 * @grammar obj.dispatchEvent(event, options)
 * @param {baidu.lang.Event|String} event	Event对象，或事件名称(1.1.1起支持)
 * @param {Object}		options 扩展参数,所含属性键值会扩展到Event对象上(1.2起支持)
 * @remark 处理会调用通过addEventListenr绑定的自定义事件回调函数之外，还会调用直接绑定到对象上面的自定义事件。例如：<br>
myobj.onMyEvent = function(){}<br>
myobj.addEventListener("onMyEvent", function(){});
 */
baidu.lang.Class.prototype.send = baidu.lang.Class.prototype.dispatchEvent = function (event, options) {
  if (baidu.lang.isString(event)) {
    event = new baidu.lang.Event(event);
  }
  !this.__listeners && (this.__listeners = {});

  // 20100603 添加本方法的第二个参数，将 options extend到event中去传递
  options = options || {};
  for (var i in options) {
    event[i] = options[i];
  }

  var j, t = this.__listeners, p = event.type;
  event.target = event.target || this;
  event.currentTarget = this;

  p.indexOf("on") !== 0 && (p = "on" + p);

  baidu.lang.isFunction(this[p]) && this[p].apply(this, arguments);

  if (typeof t[p] == "object") {
    for (j in t[p]) {
      t[p][j].apply(this, arguments);
    }
  }
  return event.returnValue;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/inherits.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/24
 */



/**
 * 为类型构造器建立继承关系
 * @name baidu.lang.inherits
 * @function
 * @grammar baidu.lang.inherits(subClass, superClass[, className])
 * @param {Function} subClass 子类构造器
 * @param {Function} superClass 父类构造器
 * @param {string} className 类名标识
 * @remark
 *
使subClass继承superClass的prototype，因此subClass的实例能够使用superClass的prototype中定义的所有属性和方法。<br>
这个函数实际上是建立了subClass和superClass的原型链集成，并对subClass进行了constructor修正。<br>
<strong>注意：如果要继承构造函数，需要在subClass里面call一下，具体见下面的demo例子</strong>

 * @shortcut inherits
 * @meta standard
 * @see baidu.lang.Class
 */
baidu.lang.inherits = function (subClass, superClass, className) {
  var key, proto,
    selfProps = subClass.prototype,
    clazz = new Function();

  clazz.prototype = superClass.prototype;
  proto = subClass.prototype = new clazz();
  for (key in selfProps) {
    proto[key] = selfProps[key];
  }
  subClass.prototype.constructor = subClass;
  subClass.superClass = superClass.prototype;

  // 类名标识，兼容Class的toString，基本没用
  if ("string" == typeof className) {
    proto._className = className;
  }
};

// 声明快捷方法
baidu.inherits = baidu.lang.inherits;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/instance.js
 * author: meizz, erik
 * version: 1.1.0
 * date: 2009/12/1
 */



/**
 * 根据参数(guid)的指定，返回对应的实例对象引用
 * @name baidu.lang.instance
 * @function
 * @grammar baidu.lang.instance(guid)
 * @param {string} guid 需要获取实例的guid
 * @meta standard
 *
 * @returns {Object|null} 如果存在的话，返回;否则返回null。
 */
baidu.lang.instance = function (guid) {
  return window[baidu.guid]._instances[guid] || null;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/isArray.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/30
 */



/**
 * 判断目标参数是否Array对象
 * @name baidu.lang.isArray
 * @function
 * @grammar baidu.lang.isArray(source)
 * @param {Any} source 目标参数
 * @meta standard
 * @see baidu.lang.isString,baidu.lang.isObject,baidu.lang.isNumber,baidu.lang.isElement,baidu.lang.isBoolean,baidu.lang.isDate
 *
 * @returns {boolean} 类型判断结果
 */
baidu.isArray = baidu.lang.isArray = function (source) {
  return '[object Array]' == Object.prototype.toString.call(source);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/isElement.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/30
 */



/**
 * 判断目标参数是否为Element对象
 * @name baidu.lang.isElement
 * @function
 * @grammar baidu.lang.isElement(source)
 * @param {Any} source 目标参数
 * @meta standard
 * @see baidu.lang.isString,baidu.lang.isObject,baidu.lang.isNumber,baidu.lang.isArray,baidu.lang.isBoolean,baidu.lang.isDate
 *
 * @returns {boolean} 类型判断结果
 */
baidu.isElement = baidu.lang.isElement = function (source) {
  return !!(source && source.nodeName && source.nodeType == 1);
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 判断目标参数是否number类型或Number对象
 * @name baidu.lang.isNumber
 * @function
 * @grammar baidu.lang.isNumber(source)
 * @param {Any} source 目标参数
 * @meta standard
 * @see baidu.lang.isString,baidu.lang.isObject,baidu.lang.isArray,baidu.lang.isElement,baidu.lang.isBoolean,baidu.lang.isDate
 *
 * @returns {boolean} 类型判断结果
 * @remark 用本函数判断NaN会返回false，尽管在Javascript中是Number类型。
 */
baidu.isNumber = baidu.lang.isNumber = function (source) {
  return '[object Number]' == Object.prototype.toString.call(source) && isFinite(source);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/isObject.js
 * author: erik
 * version: 1.1.0
 * date: 2009/12/30
 */



/**
 * 判断目标参数是否为Object对象
 * @name baidu.lang.isObject
 * @function
 * @grammar baidu.lang.isObject(source)
 * @param {Any} source 目标参数
 * @shortcut isObject
 * @meta standard
 * @see baidu.lang.isString,baidu.lang.isNumber,baidu.lang.isArray,baidu.lang.isElement,baidu.lang.isBoolean,baidu.lang.isDate
 *
 * @returns {boolean} 类型判断结果
 */
baidu.lang.isObject = function (source) {
  return 'function' == typeof source || !!(source && 'object' == typeof source);
};

// 声明快捷方法
baidu.isObject = baidu.lang.isObject;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

/**
 * 添加多个自定义事件。
 * @grammar obj.addEventListeners(events, fn)
 * @param	{object}	events	json对象，key为事件名称，value为事件被触发时应该调用的回调函数
 * @param	{Function} fn		要挂载的函数
 * @version 1.3
 */
/* addEventListeners("onmyevent,onmyotherevent", fn);
 * addEventListeners({
 *      "onmyevent"         : fn,
 *      "onmyotherevent"    : fn1
 * });
 */
baidu.lang.Class.prototype.adds = baidu.lang.Class.prototype.addEventListeners = function (events, fn) {
  if (typeof fn == 'undefined') {
    for (var i in events) {
      this.addEventListener(i, events[i]);
    }
  } else {
    events = events.split(',');
    var i = 0, len = events.length, event;
    for (; i < len; i++) {
      this.addEventListener(baidu.trim(events[i]), fn);
    }
  }
};
/*
 * Tangram
 * Copyright 2010 Baidu Inc. All rights reserved.
 *
 * @author: meizz
 * @namespace: baidu.lang.createClass
 * @version: 2010-05-13
 */

baidu.lang.Class.prototype.addOne = function (type, handler, key) {
  this.remove(type, handler).add(type, handler, key);
  return this;
};





/**
 * 创建一个类，包括创造类的构造器、继承基类Class
 * @name baidu.lang.createClass
 * @function
 * @grammar baidu.lang.createClass(constructor[, options])
 * @param {Function} constructor 类的构造器函数
 * @param {Object} [options]

 * @config {string} [className] 类名
 * @config {Function} [superClass] 父类，默认为baidu.lang.Class
 * @version 1.2
 * @remark
 *
            使用createClass能方便的创建一个带有继承关系的类。同时会为返回的类对象添加extend方法，使用obj.extend({});可以方便的扩展原型链上的方法和属性

 * @see baidu.lang.Class,baidu.lang.inherits
 *
 * @returns {Object} 一个类对象
 */

baidu.lang.createClass = function (constructor, options) {
  options = options || {};
  var superClass = options.superClass || baidu.lang.Class;

  // 创建新类的真构造器函数
  var fn = function () {
    // 继承父类的构造器
    if (superClass != baidu.lang.Class) {
      superClass.apply(this, arguments);
    } else {
      superClass.call(this);
    }
    constructor.apply(this, arguments);
  };

  fn.options = options.options || {};

  var C = function () { },
    cp = constructor.prototype;
  C.prototype = superClass.prototype;

  // 继承父类的原型（prototype)链
  var fp = fn.prototype = new C();

  // 继承传参进来的构造器的 prototype 不会丢
  for (var i in cp) fp[i] = cp[i];

  if (typeof options.className == "string") { (fp._className = options.className); }

  // 修正这种继承方式带来的 constructor 混乱的问题
  fp.constructor = cp.constructor;

  // 给类扩展出一个静态方法，以代替 baidu.object.extend()
  fn.extend = function (json) {
    for (var i in json) {
      fn.prototype[i] = json[i];
    }
    return fn;  // 这个静态方法也返回类对象本身
  };

  return fn;
};
/*
 * Tangram
 * Copyright 2010 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/decontrol.js
 * author: meizz
 * version: 1.1.0
 * $date$
 */



/**
 * 解除instance中对指定类实例的引用关系。
 * @name baidu.lang.decontrol
 * @function
 * @grammar baidu.lang.decontrol(guid)
 * @param {string} guid 类的唯一标识
 * @version 1.1.1
 * @see baidu.lang.instance
 */
baidu.lang.decontrol = function (guid) {
  var m = window[baidu.guid];
  m._instances && (delete m._instances[guid]);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */

/**
 * 创建一个baidu.lang.Class的单例实例
 * @name baidu.lang.createSingle
 * @function
 * @grammar baidu.lang.createSingle(json)
 * @param {Object} json 直接挂载到这个单例里的预定属性/方法
 * @version 1.2
 * @see baidu.lang.Class
 *
 * @returns {Object} 一个实例
 */
baidu.lang.createSingle = function (json) {
  var c = new baidu.lang.Class();

  for (var key in json) {
    c[key] = json[key];
  }
  return c;
};

/**
 * 事件中心
 * @class
 * @name baidu.lang.eventCenter
 * @author rocy
 */
baidu.lang.eventCenter = baidu.lang.eventCenter || baidu.lang.createSingle();




/**
 * 注册全局事件监听器。
 * @name baidu.lang.eventCenter.addEventListener
 * @function
 * @grammar baidu.lang.eventCenter.addEventListener(type, handler[, key])
 * @param	{string}	type			自定义事件的名称
 * @param	{Function}	handler		自定义事件被触发时应该调用的回调函数
 * @param	{string}	[key]为事件监听函数指定的名称，可在移除时使用。如果不提供，方法会默认为它生成一个全局唯一的key。
 * @remark	事件类型区分大小写。如果自定义事件名称不是以小写"on"开头，该方法会给它加上"on"再进行判断，即"click"和"onclick"会被认为是同一种事件。
 */

/**
* 移除全局事件监听器。
* @name baidu.lang.eventCenter.removeEventListener
* @grammar	baidu.lang.eventCenter.removeEventListener(type, handler)
* @function
* @param	{string}   type     事件类型
* @param	{Function|string} handler  要移除的事件监听函数或者监听函数的key
* @remark	如果第二个参数handler没有被绑定到对应的自定义事件中，什么也不做。
*/

/**
* 派发全局自定义事件，使得绑定到全局自定义事件上面的函数都会被执行。
* @name baidu.lang.eventCenter.dispatchEvent
* @grammar baidu.lang.eventCenter.dispatchEvent(event, options)
* @function
* @param {baidu.lang.Event|String}	event	Event对象，或事件名称(1.1.1起支持)
* @param {Object}	options 扩展参数,所含属性键值会扩展到Event对象上(1.2起支持)
*/

// 声明快捷方式
T.observer = T.lang.eventCenter;





/*
 * tangram
 * copyright 2011 baidu inc. all rights reserved.
 *
 * path: baidu/lang/getModule.js
 * author: leeight
 * version: 1.1.0
 * date: 2011/04/29
 */

/**
 * 增加自定义模块扩展,默认创建在当前作用域
 * @author erik, berg
 * @name baidu.lang.module
 * @function
 * @grammar baidu.lang.module(name, module[, owner])
 * @param {string} name 需要创建的模块名.
 * @param {Any} module 需要创建的模块对象.
 * @param {Object} [owner] 模块创建的目标环境，默认为window.
 * @remark
 *
            从1.1.1开始，module方法会优先在当前作用域下寻找模块，如果无法找到，则寻找window下的模块

 * @meta standard
 */
baidu.lang.module = function (name, module, owner) {
  var packages = name.split('.'),
    len = packages.length - 1,
    packageName,
    i = 0;

  // 如果没有owner，找当前作用域，如果当前作用域没有此变量，在window创建
  if (!owner) {
    try {
      if (!(new RegExp('^[a-zA-Z_\x24][a-zA-Z0-9_\x24]*\x24')).test(packages[0])) {
        throw '';
      }
      owner = eval(packages[0]);
      i = 1;
    } catch (e) {
      owner = window;
    }
  }

  for (; i < len; i++) {
    packageName = packages[i];
    if (!owner[packageName]) {
      owner[packageName] = {};
    }
    owner = owner[packageName];
  }

  if (!owner[packages[len]]) {
    owner[packages[len]] = module;
  }
};
/*
 * Tangram
 * Copyright 2010 Baidu Inc. All rights reserved.
 *
 * path: baidu/lang/toArray.js
 * author: berg
 * version: 1.0
 * date: 2010-07-05
 */





/**
 * 将一个变量转换成array
 * @name baidu.lang.toArray
 * @function
 * @grammar baidu.lang.toArray(source)
 * @param {mix} source 需要转换成array的变量
 * @version 1.3
 * @meta standard
 * @returns {array} 转换后的array
 */
baidu.lang.toArray = function (source) {
  if (source === null || source === undefined)
    return [];
  if (baidu.lang.isArray(source))
    return source;

  // The strings and functions also have 'length'
  if (typeof source.length !== 'number' || typeof source === 'string' || baidu.lang.isFunction(source)) {
    return [source];
  }

  //nodeList, IE 下调用 [].slice.call(nodeList) 会报错
  if (source.item) {
    var l = source.length, array = new Array(l);
    while (l--)
      array[l] = source[l];
    return array;
  }

  return [].slice.call(source);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/object.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */


/**
 * @namespace baidu.object 操作原生对象的方法。
 */
baidu.object = baidu.object || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */





/**
 * 判断一个对象是不是字面量对象，即判断这个对象是不是由{}或者new Object类似方式创建
 *
 * @name baidu.object.isPlain
 * @function
 * @grammar baidu.object.isPlain(source)
 * @param {Object} source 需要检查的对象
 * @remark
 * 事实上来说，在Javascript语言中，任何判断都一定会有漏洞，因此本方法只针对一些最常用的情况进行了判断
 *
 * @returns {Boolean} 检查结果
 */
baidu.object.isPlain = function (obj) {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
    key;
  if (!obj ||
    //一般的情况，直接用toString判断
    Object.prototype.toString.call(obj) !== "[object Object]" ||
    //IE下，window/document/document.body/HTMLElement/HTMLCollection/NodeList等DOM对象上一个语句为true
    //isPrototypeOf挂在Object.prototype上的，因此所有的字面量都应该会有这个属性
    //对于在window上挂了isPrototypeOf属性的情况，直接忽略不考虑
    !('isPrototypeOf' in obj)
  ) {
    return false;
  }

  //判断new fun()自定义对象的情况
  //constructor不是继承自原型链的
  //并且原型中有isPrototypeOf方法才是Object
  if (obj.constructor &&
    !hasOwnProperty.call(obj, "constructor") &&
    !hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf")) {
    return false;
  }
  //判断有继承的情况
  //如果有一项是继承过来的，那么一定不是字面量Object
  //OwnProperty会首先被遍历，为了加速遍历过程，直接看最后一项
  for (key in obj) { }
  return key === undefined || hasOwnProperty.call(obj, key);
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */





/**
 * 对一个object进行深度拷贝
 *
 * @author berg
 * @name baidu.object.clone
 * @function
 * @grammar baidu.object.clone(source)
 * @param {Object} source 需要进行拷贝的对象
 * @remark
 * 对于Object来说，只拷贝自身成员，不拷贝prototype成员
 * @meta standard
 *
 * @returns {Object} 拷贝后的新对象
 */
baidu.object.clone = function (source) {
  var result = source, i, len;
  if (!source ||
    source instanceof Number ||
    source instanceof String ||
    source instanceof Boolean) {
    return result;
  } else if (baidu.lang.isArray(source)) {
    result = [];
    var resultLen = 0;
    for (i = 0, len = source.length; i < len; i++) {
      result[resultLen++] = baidu.object.clone(source[i]);
    }
  } else if (baidu.object.isPlain(source)) {
    result = {};
    for (i in source) {
      if (source.hasOwnProperty(i)) {
        result[i] = baidu.object.clone(source[i]);
      }
    }
  }
  return result;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 */



/**
 * 将源对象的所有属性拷贝到目标对象中
 * @author erik
 * @name baidu.object.extend
 * @function
 * @grammar baidu.object.extend(target, source)
 * @param {Object} target 目标对象
 * @param {Object} source 源对象
 * @see baidu.array.merge
 * @remark
 *
1.目标对象中，与源对象key相同的成员将会被覆盖。<br>
2.源对象的prototype成员不会拷贝。

 * @shortcut extend
 * @meta standard
 *
 * @returns {Object} 目标对象
 */
baidu.extend = baidu.object.extend = function (target, source) {
  for (var p in source) {
    if (source.hasOwnProperty(p)) {
      target[p] = source[p];
    }
  }

  return target;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/page.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */


/**
 * 遍历Object中所有元素，1.1.1增加
 * @name baidu.object.each
 * @function
 * @grammar baidu.object.each(source, iterator)
 * @param {Object} source 需要遍历的Object
 * @param {Function} iterator 对每个Object元素进行调用的函数，function (item, key)
 * @version 1.1.1
 *
 * @returns {Object} 遍历的Object
 */
baidu.object.each = function (source, iterator) {
  var returnValue, key, item;
  if ('function' == typeof iterator) {
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        item = source[key];
        returnValue = iterator.call(source, item, key);

        if (returnValue === false) {
          break;
        }
      }
    }
  }
  return source;
};


/**
 * @namespace baidu.page 对页面层面的封装，包括页面的高宽属性、以及外部css和js的动态添加。
 */
baidu.page = baidu.page || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/page/getScrollTop.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */

/**
 * 获取页面高度
 * @name baidu.page.getHeight
 * @function
 * @grammar baidu.page.getHeight()
 * @see baidu.page.getWidth
 *
 * @returns {number} 页面高度
 */
baidu.page.getHeight = function () {
  var doc = document,
    body = doc.body,
    html = doc.documentElement,
    client = doc.compatMode == 'BackCompat' ? body : doc.documentElement;

  return Math.max(html.scrollHeight, body.scrollHeight, client.clientHeight);
};

/**
 * 获取页面宽度
 * @name baidu.page.getWidth
 * @function
 * @grammar baidu.page.getWidth()
 * @see baidu.page.getHeight
 * @meta standard
 * @returns {number} 页面宽度
 */
baidu.page.getWidth = function () {
  var doc = document,
    body = doc.body,
    html = doc.documentElement,
    client = doc.compatMode == 'BackCompat' ? body : doc.documentElement;

  return Math.max(html.scrollWidth, body.scrollWidth, client.clientWidth);
};


/**
 * 获取纵向滚动量
 * @name baidu.page.getScrollTop
 * @function
 * @grammar baidu.page.getScrollTop()
 * @see baidu.page.getScrollLeft
 * @meta standard
 * @returns {number} 纵向滚动量
 */
baidu.page.getScrollTop = function () {
  var d = document;
  return window.pageYOffset || d.documentElement.scrollTop || d.body.scrollTop;
};

/**
 * 获取横向滚动量
 *
 * @return {number} 横向滚动量
 */
baidu.page.getScrollLeft = function () {
  var d = document;
  return window.pageXOffset || d.documentElement.scrollLeft || d.body.scrollLeft;
};

/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/page/getViewHeight.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/20
 */



/**
 * 获取页面视觉区域高度
 * @name baidu.page.getViewHeight
 * @function
 * @grammar baidu.page.getViewHeight()
 * @see baidu.page.getViewWidth
 * @meta standard
 * @returns {number} 页面视觉区域高度
 */
baidu.page.getViewHeight = function (withScrollbar) {
  var doc = document,
    client = doc.compatMode == 'BackCompat' ? doc.body : doc.documentElement;

  // 是否包含滚动条宽度
  if (withScrollbar) {
    return client.clientHeight + _getScrollbarSize().height;
  } else {
    return client.clientHeight;
  }
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/page/getViewWidth.js
 * author: allstar
 * version: 1.1.0
 * date: 2009/11/20
 */



/**
 * 获取页面视觉区域宽度
 * @name baidu.page.getViewWidth
 * @function
 * @grammar baidu.page.getViewWidth()
 * @see baidu.page.getViewHeight
 *
 * @returns {number} 页面视觉区域宽度
 */
baidu.page.getViewWidth = function (withScrollbar) {
  var doc = document,
    client = doc.compatMode == 'BackCompat' ? doc.body : doc.documentElement;
  // 是否包含滚动条宽度
  if (withScrollbar) {
    return client.clientWidth + _getScrollbarSize().width;
  } else {
    return client.clientWidth;
  }
};
/**
 * 获取浏览器滚动条宽高
 * @returns {{width: number, height: number}}
 * @private
 */
function _getScrollbarSize () {
  var $div = document.createElement('div');
  $div.id = '__detect__';
  $div.style.overflow = 'scroll';
  $div.style.visibility = 'hidden';
  $div.style.position = 'absolute';
  $div.style.width = '100px';
  $div.style.height = '100px';
  document.body.appendChild($div);
  var hw = {
    width: $div.offsetWidth - $div.clientWidth,
    height: $div.offsetHeight - $div.clientHeight
  };
  $div.parentNode.removeChild($div);
  return hw;
}

/**
 * 延迟加载图片. 默认只加载可见高度以上的图片, 随着窗口滚动加载剩余图片.注意: 仅支持垂直方向.
 * @name baidu.page.lazyLoadImage
 * @function
 * @grammar baidu.page.lazyLoadImage([options])
 * @param {Object} options
 * @param {String} [options.className] 延迟加载的IMG的className,如果不传入该值将延迟加载所有IMG.
 * @param {Number} [options.preloadHeight] 预加载的高度, 可见窗口下该高度内的图片将被加载.
 * @param {String} [options.placeHolder] 占位图url.
 * @param {Function} [options.onlazyload] 延迟加载回调函数,在实际加载时触发.
 * @author rocy
 */
(function () {
  //计算需要加载图片的页面高度
  var options = {}, targets = [], delayTimer = 0;
  var getLoadOffset = function () {
    var scrollTop = baidu.page.getScrollTop();
    return {
      top: scrollTop,
      bottom: scrollTop + baidu.page.getViewHeight() + options.preloadHeight
    }
  }
  var onImageLoad = function () {
    //fix by wangxk
    //当图片在浏览器缓存中时,不论图片是否0字节,都会触发onload
    //T.un(this, 'load', onImageLoad);
    //T.un(this, 'error', onImageError);
    T.addClass(this, 'lazy-alpha-end');
    //add by wangxk
    T.removeClass(this, 'lazy-alpha-start');
    T.removeClass(this, 'lazy-alpha-end');
  };
  var onImageError = function () {
    //T.un(this, 'load', onImageLoad);
    //T.un(this, 'error', onImageError);
    T.addClass(this, 'lazy-alpha-error');
    //add by wangxk
    T.removeClass(this, 'lazy-alpha-start');
    T.removeClass(this, 'lazy-alpha-end');
  };
  //处理延迟加载
  var loadNeeded = function () {
    clearTimeout(delayTimer);
    var viewOffset = getLoadOffset(),
      imgSrc,
      finished = true,
      i = 0,
      len = targets.length,
      target = null,
      offset = null,
      offsetHeight = 0;
    for (; i < len; ++i) {
      target = targets[i];
      imgSrc = target.getAttribute(options.attr);
      //可能是异步加载进来的数据，读不到 _lazyignore属性，加载的时候再处理下
      if (target.getAttribute("_lazyignore") == "1") {
        continue;
      }
      imgSrc && (finished = false);
      if (!imgSrc) continue;
      offset = baidu.dom.getPosition(target);
      offsetHeight = target.offsetHeight;
      if (offset.top + offsetHeight >= viewOffset.top && offset.top <= viewOffset.bottom) {
        if (!T.browser.ie) {
          if (T.dom.hasAttr(target, options.attr)) {
            T.addClass(target, 'lazy-alpha-start');
          }

          //T.on(target, 'load', onImageLoad);
          //T.on(target, 'error', onImageError);
          target.onload = onImageLoad;
          target.onerror = onImageError;
        }
        target.src = imgSrc;
        target.removeAttribute(options.attr);
        baidu.lang.isFunction(options.onlazyload) && options.onlazyload(target);
      }
    }
    //当全部图片都已经加载, 去掉事件监听
    if (finished) baidu.page.lazyLoadDispose();
  };
  var delayLoad = function () {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(loadNeeded, 100);
  };
  baidu.page.lazyLoadImage = function (option) {
    this.lazyLoadDispose();
    options = option || {};
    options.preloadHeight = options.preloadHeight || 0;
    options.attr = options.attr || '_lazysrc';
    var imgs = document.getElementsByTagName('IMG'), len = imgs.length, i = 0;
    targets = [];
    for (; i < len; ++i) {
      if (baidu.dom.hasAttr(imgs[i], options.attr) && !baidu.dom.hasAttr(imgs[i], '_lazyignore')) {
        targets.push(imgs[i]);
      }
    }
    loadNeeded();
    baidu.on(window, 'scroll', delayLoad);
    baidu.on(window, 'resize', delayLoad);
    T.observer.addOne(F.EventCenter.PAGE_RESPONSE, delayLoad);
  };
  baidu.page.lazyLoadDispose = function () {
    clearTimeout(delayTimer);
    baidu.un(window, 'scroll', loadNeeded);
    baidu.un(window, 'resize', loadNeeded);
    var i = 0, len = targets.length, target = null;
    for (; i < len; ++i) {
      target = targets[i];
      //T.un(target, 'load', onImageLoad);
      //T.un(target, 'error', onImageError);
      target.onload = null;
      target.onerror = null;
    };
    targets = [];
  };
})();


/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/decodeHTML.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */



/**
 * 对目标字符串进行html解码
 * @name baidu.string.decodeHTML
 * @function
 * @grammar baidu.string.decodeHTML(source)
 * @param {string} source 目标字符串
 * @shortcut decodeHTML
 * @meta standard
 * @see baidu.string.encodeHTML
 *
 * @returns {string} html解码后的字符串
 */
baidu.string.decodeHTML = function (source) {
  var str = String(source)
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, "&");
  //处理转义的中文和实体字符
  return str.replace(/&#([\d]+);/g, function (_0, _1) {
    return String.fromCharCode(parseInt(_1, 10));
  });
};

baidu.decodeHTML = baidu.string.decodeHTML;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/encodeHTML.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */



/**
 * 对目标字符串进行html编码
 * @name baidu.string.encodeHTML
 * @function
 * @grammar baidu.string.encodeHTML(source)
 * @param {string} source 目标字符串
 * @remark
 * 编码字符有5个：&<>"'
 * @shortcut encodeHTML
 * @meta standard
 * @see baidu.string.decodeHTML
 *
 * @returns {string} html编码后的字符串
 */
baidu.string.encodeHTML = function (source) {
  return String(source)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

baidu.encodeHTML = baidu.string.encodeHTML;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/format.js
 * author: dron, erik
 * version: 1.1.0
 * date: 2009/11/30
 */

/**
 * 对目标字符串按gbk编码截取字节长度
 * @name baidu.string.subByte
 * @function
 * @grammar baidu.string.subByte(source, length)
 * @param {string} source 目标字符串
 * @param {number} length 需要截取的字节长度
 * @param {string} [tail] 追加字符串,可选.
 * @remark
 * 截取过程中，遇到半个汉字时，向下取整。
 * @see baidu.string.getByteLength
 *
 * @returns {string} 字符串截取结果
 */
baidu.string.subByte = function (source, length, tail) {
  source = String(source);
  tail = tail || '';
  if (length < 0 || baidu.string.getByteLength(source) <= length) {
    return source + tail;
  }

  //thanks 加宽提供优化方法
  source = source.substr(0, length).replace(/([^\x00-\xff])/g, "\x241 ")//双字节字符替换成两个
    .substr(0, length)//截取长度
    .replace(/[^\x00-\xff]$/, "")//去掉临界双字节字符
    .replace(/([^\x00-\xff]) /g, "\x241");//还原
  return source + tail;

};

/**
 * 对目标字符串进行格式化
 * @name baidu.string.format
 * @function
 * @grammar baidu.string.format(source, opts)
 * @param {string} source 目标字符串
 * @param {Object|string...} opts 提供相应数据的对象或多个字符串
 * @remark
 *
 *opts参数为“Object”时，替换目标字符串中的#{property name}部分。<br>
 *opts为“string...”时，替换目标字符串中的#{0}、#{1}...部分。
 *
 * @shortcut format
 * @meta standard
 *
 * @returns {string} 格式化后的字符串
 */
baidu.string.format = function (source, opts) {
  source = String(source);
  var data = Array.prototype.slice.call(arguments, 1), toString = Object.prototype.toString;
  if (data.length) {
    data = data.length === 1 ?
      /* ie 下 Object.prototype.toString.call(null) == '[object Object]' */
      (opts !== null && (/\[object Array\]|\[object Object\]/.test(toString.call(opts))) ? opts : data)
      : data;
    return source.replace(/#\{(.+?)\}/g, function (match, key) {
      var replacer = data[key];
      //chrome下typeof /a/ == 'function'
      if ('[object Function]' == toString.call(replacer)) {
        replacer = replacer(key);
      }
      return ('undefined' == typeof replacer ? '' : replacer);
    });
  }
  return source;
};

// 声明快捷方法
baidu.format = baidu.string.format;
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/string/getByteLength.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/15
 */



/**
 * 获取目标字符串在gbk编码下的字节长度
 * @name baidu.string.getByteLength
 * @function
 * @grammar baidu.string.getByteLength(source)
 * @param {string} source 目标字符串
 * @remark
 * 获取字符在gbk编码下的字节长度, 实现原理是认为大于127的就一定是双字节。如果字符超出gbk编码范围, 则这个计算不准确
 * @meta standard
 * @see baidu.string.subByte
 *
 * @returns {number} 字节长度
 */
baidu.string.getByteLength = function (source) {
  return String(source).replace(/[^\x00-\xff]/g, "ci").length;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/swf.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/16
 */


/**
 * @namespace baidu.swf 操作flash对象的方法，包括创建flash对象、获取flash对象以及判断flash插件的版本号。
*/
baidu.swf = baidu.swf || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/swf/version.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 浏览器支持的flash插件版本
 * @property version 浏览器支持的flash插件版本
 * @grammar baidu.swf.version
 * @return {String} 版本号
 * @meta standard
 */
baidu.swf.version = (function () {
  var n = navigator, isPlugins = false;

  // 读取 navigator.mimeTypes 对象的属性时,有可能报 "加载 DLL 时出错"
  try { isPlugins = (n.plugins && n.mimeTypes.length); } catch (ex) { }

  if (isPlugins) {
    var plugin = n.plugins["Shockwave Flash"];
    if (plugin && plugin.description) {
      return plugin.description.replace(/([a-zA-Z]|\s)+/, "").replace(/(\s)+r/, ".") + ".0";
    }
  } else if (window.ActiveXObject && !window.opera) {
    for (var i = 12; i >= 2; i--) {
      try {
        var c = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.' + i);
        if (c) {
          var version = c.GetVariable("$version");
          return version.replace(/WIN/g, '').replace(/,/g, '.');
        }
      } catch (e) { }
    }
  }
}
)();
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/swf/createHTML.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */




/**
 * 创建flash对象的html字符串
 * @name baidu.swf.createHTML
 * @function
 * @grammar baidu.swf.createHTML(options)
 *
 * @param	{Object}	options						创建flash的选项参数
 * @param	{string}	options.id					要创建的flash的标识
 * @param	{string}	options.url					flash文件的url
 * @param	{String}	options.errorMessage 		未安装flash player或flash player版本号过低时的提示
 * @param	{string}	options.ver					最低需要的flash player版本号
 * @param	{string}	options.width				flash的宽度
 * @param	{string}	options.height				flash的高度
 * @param	{string}	options.align				flash的对齐方式，允许值：middle/left/right/top/bottom
 * @param	{string}	options.base				设置用于解析swf文件中的所有相对路径语句的基本目录或URL
 * @param	{string}	options.bgcolor				swf文件的背景色
 * @param	{string}	options.salign				设置缩放的swf文件在由width和height设置定义的区域内的位置。允许值：l/r/t/b/tl/tr/bl/br
 * @param	{boolean}	options.menu				是否显示右键菜单，允许值：true/false
 * @param	{boolean}	options.loop				播放到最后一帧时是否重新播放，允许值： true/false
 * @param	{boolean}	options.play				flash是否在浏览器加载时就开始播放。允许值：true/false
 * @param	{string}	options.quality				设置flash播放的画质，允许值：low/medium/high/autolow/autohigh/best
 * @param	{string}	options.scale				设置flash内容如何缩放来适应设置的宽高。允许值：showall/noborder/exactfit
 * @param	{string}	options.wmode				设置flash的显示模式。允许值：window/opaque/transparent
 * @param	{string}	options.allowscriptaccess	设置flash与页面的通信权限。允许值：always/never/sameDomain
 * @param	{string}	options.allownetworking		设置swf文件中允许使用的网络API。允许值：all/internal/none
 * @param	{boolean}	options.allowfullscreen		是否允许flash全屏。允许值：true/false
 * @param	{boolean}	options.seamlesstabbing		允许设置执行无缝跳格，从而使用户能跳出flash应用程序。该参数只能在安装Flash7及更高版本的Windows中使用。允许值：true/false
 * @param	{boolean}	options.devicefont			设置静态文本对象是否以设备字体呈现。允许值：true/false
 * @param	{boolean}	options.swliveconnect		第一次加载flash时浏览器是否应启动Java。允许值：true/false
 * @param	{Object}	options.vars				要传递给flash的参数，支持JSON或string类型。
 *
 * @see baidu.swf.create
 * @meta standard
 * @returns {string} flash对象的html字符串
 */
baidu.swf.createHTML = function (options) {
  options = options || {};
  var version = baidu.swf.version,
    needVersion = options.ver || '6.0.0',
    vUnit1, vUnit2, i, k, len, item, tmpOpt = {},
    encodeHTML = baidu.string.encodeHTML;

  // 复制options，避免修改原对象
  for (k in options) {
    tmpOpt[k] = options[k];
  }
  options = tmpOpt;
  // 浏览器支持的flash插件版本判断
  if (version) {
    version = version.split('.');
    needVersion = needVersion.split('.');
    for (i = 0; i < 3; i++) {
      vUnit1 = parseInt(version[i], 10);
      vUnit2 = parseInt(needVersion[i], 10);
      if (vUnit2 < vUnit1) {
        break;
      } else if (vUnit2 > vUnit1) {
        return ''; // 需要更高的版本号
      }
    }
  } else {
    return ''; // 未安装flash插件
  }

  var vars = options.vars,
    objProperties = ['classid', 'codebase', 'id', 'width', 'height', 'align'];

  // 初始化object标签需要的classid、codebase属性值
  options.align = options.align || 'middle';
  options.classid = 'clsid:d27cdb6e-ae6d-11cf-96b8-444553540000';
  options.codebase = 'http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,0,0';
  options.movie = options.url || '';
  delete options.vars;
  delete options.url;

  // 初始化flashvars参数的值
  if ('string' == typeof vars) {
    options.flashvars = vars;
  } else {
    var fvars = [];
    for (k in vars) {
      item = vars[k];
      fvars.push(k + "=" + encodeURIComponent(item));
    }
    options.flashvars = fvars.join('&');
  }

  // 构建IE下支持的object字符串，包括属性和参数列表
  var str = ['<object '];
  for (i = 0, len = objProperties.length; i < len; i++) {
    item = objProperties[i];
    str.push(' ', item, '="', encodeHTML(options[item]), '"');
  }
  str.push('>');
  var params = {
    'wmode': 1,
    'scale': 1,
    'quality': 1,
    'play': 1,
    'loop': 1,
    'menu': 1,
    'salign': 1,
    'bgcolor': 1,
    'base': 1,
    'allowscriptaccess': 1,
    'allownetworking': 1,
    'allowfullscreen': 1,
    'seamlesstabbing': 1,
    'devicefont': 1,
    'swliveconnect': 1,
    'flashvars': 1,
    'movie': 1
  };
  for (k in options) {
    item = options[k];
    k = k.toLowerCase();
    if (params[k] && (item || item === false || item === 0)) {
      str.push('<param name="' + k + '" value="' + encodeHTML(item) + '" />');
    }
  }
  // 使用embed时，flash地址的属性名是src，并且要指定embed的type和pluginspage属性
  options.src = options.movie;
  options.name = options.id;
  delete options.id;
  delete options.movie;
  delete options.classid;
  delete options.codebase;
  options.type = 'application/x-shockwave-flash';
  options.pluginspage = 'http://www.macromedia.com/go/getflashplayer';


  // 构建embed标签的字符串
  str.push('<embed');
  // 在firefox、opera、safari下，salign属性必须在scale属性之后，否则会失效
  // 经过讨论，决定采用BT方法，把scale属性的值先保存下来，最后输出
  var salign;
  for (k in options) {
    item = options[k];
    if (item || item === false || item === 0) {
      if ((new RegExp("^salign\x24", "i")).test(k)) {
        salign = item;
        continue;
      }
      str.push(' ', k, '="', encodeHTML(item), '"');
    }
  }
  if (salign) {
    str.push(' salign="', encodeHTML(salign), '"');
  }
  str.push('></embed></object>');
  return str.join('');
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/swf/create.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/17
 */



/**
 * 在页面中创建一个flash对象
 * @name baidu.swf.create
 * @function
 * @grammar baidu.swf.create(options[, container])
 *
 * @param {Object}	options						创建flash的选项参数
 * @param {string}	options.id					要创建的flash的标识
 * @param {string}	options.url					flash文件的url
 * @param {String}	options.errorMessage		未安装flash player或flash player版本号过低时的提示
 * @param {string}	options.ver					最低需要的flash player版本号
 * @param {string}	options.width				flash的宽度
 * @param {string}	options.height				flash的高度
 * @param {string}	options.align				flash的对齐方式，允许值：middle/left/right/top/bottom
 * @param {string}	options.base				设置用于解析swf文件中的所有相对路径语句的基本目录或URL
 * @param {string}	options.bgcolor				swf文件的背景色
 * @param {string}	options.salign				设置缩放的swf文件在由width和height设置定义的区域内的位置。允许值：l/r/t/b/tl/tr/bl/br
 * @param {boolean}	options.menu				是否显示右键菜单，允许值：true/false
 * @param {boolean}	options.loop				播放到最后一帧时是否重新播放，允许值： true/false
 * @param {boolean}	options.play				flash是否在浏览器加载时就开始播放。允许值：true/false
 * @param {string}	options.quality				设置flash播放的画质，允许值：low/medium/high/autolow/autohigh/best
 * @param {string}	options.scale				设置flash内容如何缩放来适应设置的宽高。允许值：showall/noborder/exactfit
 * @param {string}	options.wmode				设置flash的显示模式。允许值：window/opaque/transparent
 * @param {string}	options.allowscriptaccess	设置flash与页面的通信权限。允许值：always/never/sameDomain
 * @param {string}	options.allownetworking		设置swf文件中允许使用的网络API。允许值：all/internal/none
 * @param {boolean}	options.allowfullscreen		是否允许flash全屏。允许值：true/false
 * @param {boolean}	options.seamlesstabbing		允许设置执行无缝跳格，从而使用户能跳出flash应用程序。该参数只能在安装Flash7及更高版本的Windows中使用。允许值：true/false
 * @param {boolean}	options.devicefont			设置静态文本对象是否以设备字体呈现。允许值：true/false
 * @param {boolean}	options.swliveconnect		第一次加载flash时浏览器是否应启动Java。允许值：true/false
 * @param {Object}	options.vars				要传递给flash的参数，支持JSON或string类型。
 *
 * @param {HTMLElement|string} [container]		flash对象的父容器元素，不传递该参数时在当前代码位置创建flash对象。
 * @meta standard
 * @see baidu.swf.createHTML,baidu.swf.getMovie
 */
baidu.swf.create = function (options, target) {
  options = options || {};
  var html = baidu.swf.createHTML(options) || options.errorMessage || '';

  if (target && 'string' == typeof target) {
    target = document.getElementById(target);
  }
  if (target) {
    target.innerHTML = html;
  } else {
    document.write(html);
  }
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/swf/getMovie.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/16
 */





/**
 * 获得flash对象的实例
 * @name baidu.swf.getMovie
 * @function
 * @grammar baidu.swf.getMovie(name)
 * @param {string} name flash对象的名称
 * @see baidu.swf.create
 * @meta standard
 * @returns {HTMLElement} flash对象的实例
 */
baidu.swf.getMovie = function (name) {
  //ie9下, Object标签和embed标签嵌套的方式生成flash时,
  //会导致document[name]多返回一个Object元素,而起作用的只有embed标签

  // 在火狐下, 在frame内嵌页内也会产生多个元素
  var movie = document[name], ret;
  if (movie && movie.length) {
    movie = (ret = baidu.array.remove(baidu.lang.toArray(movie), function (item) {
      return item.tagName.toLowerCase() != "embed";
    })).length >= 1 ? ret[0] : ret;
  }

  if (baidu.browser.ie == 9 || movie) {
    ret = movie;
  } else {
    // 部分IE10浏览器下 访问window['localStorage']属性
    // 出现错误: (SCRIPT12004: 在 Microsoft Internet 扩展版本中发生内部错误)
    // 禁用所有插件与恢复设置依然存在
    try { ret = window[name]; } catch (ex) { }
  }
  return ret;
};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/url.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/16
 */


/**
 * @namespace baidu.url 操作url的方法。
 */
baidu.url = baidu.url || {};
/*
 * Tangram
 * Copyright 2009 Baidu Inc. All rights reserved.
 *
 * path: baidu/url/getQueryValue.js
 * author: erik
 * version: 1.1.0
 * date: 2009/11/16
 */




/**
 * 根据参数名从目标URL中获取参数值
 * @name baidu.url.getQueryValue
 * @function
 * @grammar baidu.url.getQueryValue(key, url)
  * @param {string} key 要获取的参数名
 * @param {string} url 目标URL
 * @meta standard
 * @see baidu.url.jsonToQuery
 *
 * @returns {string|null} - 获取的参数值，其中URI编码后的字符不会被解码，获取不到时返回null
 */
baidu.url.getQueryValue = function (key, url) {
  var reg = new RegExp(
    "(^|&|\\?|#)"
    + baidu.string.escapeReg(key)
    + "=([^&#]*)(&|\x24|#)",
    "");
  var match = (url || window.location.href).match(reg);
  if (match) {
    return match[2];
  }

  return null;
};

/**
 * 合并参数
 * @param {string} - url 被全并的url
 * @param {object} - [params=null] 参数对象
 * @author kyomic
 */
baidu.url.mergeParams = function (url, params) {
  if (params && typeof params == 'object') {
    var queryIndex = url.indexOf('?');
    if (queryIndex != -1) {
      var pstr = url.substring(queryIndex + 1);
      var parr = pstr.split("&");
      var p = {};
      for (var i = 0; i < parr.length; i++) {
        var str = parr[i].split("=");
        if (str && str[0]) {
          var val = str[1] || '';
          try {
            val = decodeURIComponent(val);
          } catch (e) {
            val = str[1] || '';
          }
          p[str[0]] = val;
        }
      }
      for (var i in params) {
        if (params[i]) {
          p[i] = params[i];
        }
      }
      var arr = [];
      for (var i in p) {
        arr.push(i + "=" + encodeURIComponent(p[i]));
      }
      url = url.substring(0, queryIndex) + "?" + arr.join("&");
    }
  }
  return url;
}

/**
 * 对字符串进行%#&+=以及和\s匹配的所有字符进行url转义
 * @name baidu.url.escapeSymbol
 * @function
 * @grammar baidu.url.escapeSymbol(source)
 * @param {string} source 需要转义的字符串.
 * @return {string} 转义之后的字符串.
 * @remark
 * 用于get请求转义。在服务器只接受gbk，并且页面是gbk编码时，可以经过本转义后直接发get请求。
 *
 * @return {string} 转义后的字符串
 */
baidu.url.escapeSymbol = function (source) {

  //TODO: 之前使用\s来匹配任意空白符
  //发现在ie下无法匹配中文全角空格和纵向指标符\v，所以改\s为\f\r\n\t\v以及中文全角空格和英文空格
  //但是由于ie本身不支持纵向指标符\v,故去掉对其的匹配，保证各浏览器下效果一致
  // 压缩后导致内部结构错误, 使用RegExp加载字符串 (edit: fl)
  return String(source).replace(new RegExp("/[#%&+=\/\\\ \　\f\r\n\t]/g"), function (all) {
    return '%' + (0x100 + all.charCodeAt()).toString(16).substring(1).toUpperCase();
  });
};

/**
 * 将json对象解析成query字符串
 * @name baidu.url.jsonToQuery
 * @function
 * @grammar baidu.url.jsonToQuery(json[, replacer])
 * @param {Object} json 需要解析的json对象
 * @param {Function=} replacer_opt 对值进行特殊处理的函数，function (value, key)
 * @see baidu.url.queryToJson,baidu.url.getQueryValue
 *
 * @return {string} - 解析结果字符串，其中值将被URI编码，{a:'&1 '} ==> "a=%261%20"。
 */
baidu.url.jsonToQuery = function (json, replacer_opt) {
  var result = [],
    itemLen,
    replacer = replacer_opt || function (value) {
      return baidu.url.escapeSymbol(value);
    };

  baidu.object.each(json, function (item, key) {
    // 这里只考虑item为数组、字符串、数字类型，不考虑嵌套的object
    if (baidu.lang.isArray(item)) {
      itemLen = item.length;
      // value的值需要encodeURIComponent转义吗？
      // FIXED 优化了escapeSymbol函数
      while (itemLen--) {
        result.push(key + '=' + replacer(item[itemLen], key));
      }
    } else {
      result.push(key + '=' + replacer(item, key));
    }
  });

  return result.join('&');
};

/**
 * 解析目标URL中的参数成json对象
 * @name baidu.url.queryToJson
 * @function
 * @grammar baidu.url.queryToJson(url)
 * @param {string} url 目标URL
 * @see baidu.url.jsonToQuery
 *
 * @returns {Object} - 解析为结果对象，其中URI编码后的字符不会被解码，'a=%20' ==> {a:'%20'}。
 */
baidu.url.queryToJson = function (url) {
  var query = url.substr(url.lastIndexOf('?') + 1),
    params = query.split('&'),
    len = params.length,
    result = {},
    i = 0,
    key, value, item, param;

  for (; i < len; i++) {
    if (!params[i]) {
      continue;
    }
    param = params[i].split('=');
    key = param[0];
    value = param[1];

    item = result[key];
    if ('undefined' == typeof item) {
      result[key] = value;
    } else if (baidu.lang.isArray(item)) {
      item.push(value);
    } else { // 这里只可能是string了
      result[key] = [item, value];
    }
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/assets/js/core.js